/* Generated by scripts/build_shopify.py: src/backdrop.js + src/engine.js + src/shopify.js. Edit src/, then rebuild. */
/* Backdrop for The Armory: one full-screen shader, nine rooms (index = THEMES order in engine.js).
   0 limestone plaster        1 open sky, cumulus drifting across     2 black castle stone
   3 deep green forest        4 galaxy                                5 digital rain (falling glyphs)
   6 night of floating 8-bit lanterns   7 white wall, cherry tree, falling petals   8 limestone with butterflies + birds
   Wall rooms (0 2 7 8) have a soft key light from the upper left and catch the rack's shadows. Open rooms (1 3 4 5 6)
   have no wall: the rail's brackets are bolted into the scene itself, and it cracks around each bolt.
   The removed rooms (white gallery, concrete, sandy castle, boho) are in src/archive/.
   Coordinates are CSS px, y down. */
window.OTK_BACKDROP = {
vert: `
void main(){ gl_Position = vec4(position.xy, 0.9999, 1.0); }`,
frag: `
precision highp float;
uniform vec2 uRes; uniform float uDpr, uTime;
uniform int uTheme, uPrev; uniform float uMix; uniform vec2 uReveal;
uniform vec4 uRail; uniform vec2 uRailOff; uniform float uRailDepth;
uniform float uS;                                   // garment scale (px): sizes cracks, creatures, petals
uniform sampler2D uSakura, uGlyphs; uniform float uSakuraAspect;

float h21(vec2 p){ p = fract(p * vec2(123.34, 456.21)); p += dot(p, p + 45.32); return fract(p.x * p.y); }
float vn(vec2 p){ vec2 i = floor(p), f = fract(p); vec2 u = f * f * (3.0 - 2.0 * f);
  return mix(mix(h21(i), h21(i + vec2(1.0, 0.0)), u.x), mix(h21(i + vec2(0.0, 1.0)), h21(i + vec2(1.0, 1.0)), u.x), u.y); }
float fbm(vec2 p){ float s = 0.0, a = 0.5; for (int i = 0; i < 5; i++){ s += a * vn(p); p = p * 2.03 + vec2(17.1, 9.2); a *= 0.5; } return s; }
float fbm3(vec2 p){ float s = 0.0, a = 0.5; for (int i = 0; i < 3; i++){ s += a * vn(p); p = p * 2.07 + vec2(5.3, 11.7); a *= 0.5; } return s; }
mat2 rot(float a){ float c = cos(a), s = sin(a); return mat2(c, -s, s, c); }
float bayer2(vec2 a){ a = floor(a); return fract(dot(a, vec2(0.5, a.y * 0.75))); }
float bayer4(vec2 a){ return bayer2(0.5 * a) * 0.25 + bayer2(a); }
float sdSeg(vec2 p, vec2 a, vec2 b){ vec2 pa = p - a, ba = b - a; return length(pa - ba * clamp(dot(pa, ba) / dot(ba, ba), 0.0, 1.0)); }
float lum(vec3 c){ return dot(c, vec3(0.299, 0.587, 0.114)); }

/* =============================== wall rooms =============================== */
vec4 limestone(vec2 p){
  return vec4(vec3(0.80, 0.785, 0.75) * (0.94 + 0.08 * fbm3(p * 0.004 + 3.0)) * (0.97 + 0.03 * vn(p * 0.2)),
              fbm(p * 0.012) * 0.6 + vn(p * 0.09) * 0.25 + vn(p * 0.35) * 0.15);
}
// black castle: coursed rubble ashlar in near-black basalt, pillowed faces, deep dusty joints
vec4 blackStone(vec2 p){
  float rowH = 68.0; float row = floor(p.y / rowH); float ly = p.y - row * rowH;
  float x = p.x + h21(vec2(row, 3.0)) * 400.0;
  float k = floor(x / 130.0);
  float b0 = k * 130.0 + (h21(vec2(k, row)) - 0.5) * 70.0, b1 = (k + 1.0) * 130.0 + (h21(vec2(k + 1.0, row)) - 0.5) * 70.0;
  if (x < b0) { b1 = b0; k -= 1.0; b0 = k * 130.0 + (h21(vec2(k, row)) - 0.5) * 70.0; }
  else if (x > b1) { b0 = b1; k += 1.0; b1 = (k + 1.0) * 130.0 + (h21(vec2(k + 1.0, row)) - 0.5) * 70.0; }
  float lx = x - b0, w = b1 - b0;
  float e = min(min(lx, w - lx), min(ly, rowH - ly)) + (fbm3(p * 0.06) - 0.5) * 7.0;
  float id = h21(vec2(k, row) + 0.37);
  float mortar = smoothstep(5.5, 2.0, e);
  float pillow = pow(smoothstep(0.0, 16.0, e), 0.7);
  float face = fbm(p * 0.045 + id * 31.0);
  float chip = smoothstep(0.62, 0.8, vn(p * 0.12 + id * 9.0)) * smoothstep(14.0, 3.0, e);
  float grit = vn(p * 0.32 + id * 13.0) * 0.5 + vn(p * 0.9) * 0.5;
  float h = pillow * (0.75 + face * 0.6 + grit * 0.12) - chip * 0.45 - mortar * 0.9 + vn(p * 1.3) * 0.08 * mortar;
  vec3 c1 = vec3(0.115, 0.112, 0.118), c2 = vec3(0.165, 0.157, 0.15), c3 = vec3(0.085, 0.09, 0.1);
  vec3 stone = id < 0.4 ? mix(c1, c2, id / 0.4) : id < 0.75 ? mix(c2, c3, (id - 0.4) / 0.35) : mix(c3, c1 * 1.1, (id - 0.75) / 0.25);
  stone *= (0.78 + 0.4 * face) * (0.9 + 0.16 * grit);
  stone *= 1.0 - 0.25 * smoothstep(0.45, 0.8, fbm3(vec2(p.x * 0.03, p.y * 0.004)));       // soot runs
  stone *= 1.0 - 0.3 * chip;
  vec3 mort = vec3(0.21, 0.2, 0.19) * (0.85 + 0.3 * vn(p * 0.8));
  vec3 a = mix(stone, mort, mortar);
  a *= 0.75 + 0.25 * smoothstep(0.0, 10.0, e + 3.0);
  return vec4(a, h);
}
vec4 surf(int t, vec2 p){
  if (t == 2) return blackStone(p);
  if (t == 7) return vec4(vec3(0.95, 0.947, 0.94) * (0.988 + 0.012 * fbm3(p * 0.003)), vn(p * 0.6) * 0.05 + fbm3(p * 0.008) * 0.08);
  return limestone(p);
}
float bumpK(int t){ return t == 2 ? 3.4 : t == 7 ? 0.8 : 1.3; }
float ambient(int t){ return t == 2 ? 0.42 : t == 7 ? 0.86 : 0.78; }
float keyI(int t){ return t == 2 ? 0.95 : t == 7 ? 0.32 : 0.5; }
vec3 keyC(int t){ return t == 2 ? vec3(1.0, 0.92, 0.8) : t == 7 ? vec3(1.0, 0.98, 0.95) : vec3(1.0, 0.94, 0.84); }

// ---- cherry tree (texture, anchored bottom-left, taller than the room) with petals drifting down from it
vec4 treeAt(vec2 p, float bias){
  float h = uRes.y * 1.06, w = h * uSakuraAspect;
  vec2 uv = (p - vec2(0.0, uRes.y - h)) / vec2(w, h);
  vec4 c = texture2D(uSakura, vec2(uv.x, 1.0 - uv.y), bias);           // sample first, then mask (see engine.js samp)
  return (uv.x < 0.0 || uv.x > 1.0 || uv.y < 0.0 || uv.y > 1.0) ? vec4(0.0) : c;
}
vec4 petals(vec2 p, float t){
  vec4 acc = vec4(0.0);
  float k = uRes.y / 860.0, canopyR = min(uRes.x, uRes.y * 1.06 * uSakuraAspect * 0.78);
  for (int L = 0; L < 2; L++){
    float fl = float(L), cell = (L == 0 ? 52.0 : 84.0) * k;
    vec2 wind = vec2(16.0 + 12.0 * fl, 30.0 + 16.0 * fl) * k;            // drifting right and down, nearer = faster
    vec2 g = (p - wind * t) / cell + fl * 31.0;
    vec2 id = floor(g), f = fract(g);
    float h = h21(id + fl * 7.0);
    float dens = mix(0.06, 0.5, smoothstep(canopyR * 1.15, canopyR * 0.25, p.x));   // most fall under the canopy
    if (h > dens) continue;
    vec2 d = (f - (vec2(h21(id + 1.3), h21(id + 2.7)) * 0.5 + 0.25)) * cell;
    d.x += sin(t * 1.3 + h * 40.0) * 6.0 * k;                             // flutter
    d = rot(t * (0.8 + 1.8 * h21(id + 4.4)) + h * 20.0) * d;
    float flip = abs(sin(t * (1.2 + 1.6 * h) + h * 9.0));                 // tumbling: turns edge-on and back
    vec2 sz = vec2(5.2, 3.8) * k * (0.85 + 0.45 * fl);
    vec2 e = d / (sz * vec2(max(flip, 0.18), 1.0));
    float r = length(e) + 0.35 * smoothstep(0.5, 1.0, e.y) * smoothstep(0.3, 0.0, abs(e.x));   // notched tip
    float a = smoothstep(1.0, 0.82, r);
    vec3 pc = mix(vec3(0.99, 0.83, 0.88), vec3(0.95, 0.64, 0.75), h21(id + 6.0)) * (0.82 + 0.18 * flip);
    acc = vec4(mix(acc.rgb, pc, a), max(acc.a, a));
  }
  return acc;
}
vec3 sakura(vec2 p, vec3 col, vec3 lf){
  float k = uRes.y / 860.0;
  col *= 1.0 - 0.2 * treeAt(p - vec2(12.0, 20.0) * k, 3.5).a;              // the tree's soft shadow on the wall
  vec4 tr = treeAt(p, 0.0);
  col = mix(col, tr.rgb * lf, tr.a);
  col *= 1.0 - 0.1 * petals(p - vec2(5.0, 9.0) * k, uTime).a;               // petal shadows
  vec4 pe = petals(p, uTime);
  return mix(col, pe.rgb * lf * 1.04, pe.a);
}

// ---- butterflies and swallows over the limestone, each with a soft shadow on the wall
vec4 butterfly(vec2 p, float i, float t, float k){
  float dir = mod(i, 2.0) < 1.0 ? 1.0 : -1.0;
  float sp = (22.0 + 16.0 * h21(vec2(i, 1.0))) * k;
  float span = uRes.x + 240.0 * k;
  float x = mod(h21(vec2(i, 2.0)) * span + dir * t * sp, span) - 120.0 * k;
  float y = (0.12 + 0.76 * h21(vec2(i, 3.0))) * uRes.y + sin(t * 0.8 + i * 2.1) * 34.0 * k + sin(t * 2.3 + i) * 9.0 * k;
  vec2 d = p - vec2(x, y);
  float sz = (21.0 + 11.0 * h21(vec2(i, 4.0))) * k;
  if (dot(d, d) > sz * sz * 4.0) return vec4(0.0);
  float tilt = dir * 0.35 + sin(t * 1.7 + i) * 0.15;
  d = rot(-tilt) * d / sz;
  float flap = 0.18 + 0.82 * abs(sin(t * (9.0 + 4.0 * h21(vec2(i, 5.0))) + i * 3.0));
  vec2 q = vec2(abs(d.x) / flap, d.y);
  vec2 fw = rot(-0.45) * (q - vec2(0.55, -0.28)) / vec2(0.62, 0.46);       // forewing
  vec2 hw = rot(0.35) * (q - vec2(0.4, 0.32)) / vec2(0.44, 0.36);          // hindwing
  float wing = min(length(fw), length(hw));
  float a = smoothstep(1.0, 0.9, wing);
  float body = smoothstep(0.12, 0.06, abs(d.x)) * smoothstep(0.75, 0.6, abs(d.y + 0.05));
  float sp4 = floor(h21(vec2(i, 6.0)) * 4.0);
  vec3 base = sp4 < 1.0 ? vec3(0.95, 0.5, 0.1) : sp4 < 2.0 ? vec3(0.16, 0.45, 0.95) : sp4 < 3.0 ? vec3(0.97, 0.96, 0.9) : vec3(0.98, 0.84, 0.3);
  float edge = smoothstep(0.62, 0.9, wing);
  float veins = smoothstep(0.08, 0.0, abs(fract(atan(q.y, q.x) * 2.2) - 0.5) - 0.42) * step(wing, 0.9);
  vec3 c = mix(base, vec3(0.05), max(edge * (sp4 < 3.0 ? 0.9 : 0.6), veins * (sp4 < 1.0 ? 0.8 : 0.25)));
  c = mix(c, vec3(1.0), smoothstep(0.08, 0.0, length(fract(q * 7.0) - 0.5) - 0.06) * edge * 0.8);   // white dots in the margin
  c *= 0.85 + 0.3 * (1.0 - flap) * step(d.x, 0.0);                          // the near wing catches the light
  return vec4(mix(c, vec3(0.08, 0.06, 0.05), body), max(a, body));
}
vec4 swallow(vec2 p, float i, float t, float k){
  float period = 13.0 + 7.0 * h21(vec2(i, 8.0));
  float ph = mod(t + h21(vec2(i, 9.0)) * period, period);
  float sp = (190.0 + 60.0 * h21(vec2(i, 10.0))) * k, dir = h21(vec2(i, 11.0)) < 0.5 ? 1.0 : -1.0;
  float x = dir > 0.0 ? -80.0 * k + ph * sp : uRes.x + 80.0 * k - ph * sp;
  float y = (0.1 + 0.35 * h21(vec2(i, 12.0))) * uRes.y + sin(x * 0.006 + i) * 46.0 * k;
  vec2 d = p - vec2(x, y);
  float sz = (17.0 + 6.0 * h21(vec2(i, 13.0))) * k;
  if (dot(d, d) > sz * sz * 9.0) return vec4(0.0);
  d = vec2(d.x * dir, d.y) / sz;
  float flap = sin(t * 11.0 + i * 5.0);                                     // seen from the side: one wing sweeps up and down
  vec2 sh = vec2(0.15, 0.0), el = vec2(-0.05, -0.62 * flap), tip = vec2(-0.55, -1.05 * flap - 0.1);
  float wingD = min(sdSeg(d, sh, el), sdSeg(d, el, tip));
  float bodyD = length((d - vec2(0.05, 0.0)) / vec2(0.62, 0.17)) - 1.0;
  float tail = min(sdSeg(d, vec2(-0.5, 0.0), vec2(-1.05, -0.22)), sdSeg(d, vec2(-0.5, 0.0), vec2(-1.05, 0.22)));
  float a = max(smoothstep(0.13, 0.06, wingD), max(smoothstep(0.05, -0.05, bodyD), smoothstep(0.06, 0.02, tail)));
  return vec4(vec3(0.1, 0.1, 0.12), a);
}
vec3 garden(vec2 p, vec3 col, vec3 lf){
  float k = uRes.y / 860.0, t = uTime;
  for (int j = 0; j < 7; j++){
    float i = float(j);
    col *= 1.0 - 0.16 * butterfly(p - vec2(9.0, 15.0) * k, i, t, k).a;       // shadow on the wall
    vec4 b = butterfly(p, i, t, k);
    col = mix(col, b.rgb * lf, b.a);
  }
  for (int j = 0; j < 3; j++){
    float i = float(j);
    col *= 1.0 - 0.1 * swallow(p - vec2(26.0, 40.0) * k, i, t, k).a;
    vec4 b = swallow(p, i, t, k);
    col = mix(col, b.rgb * lf, b.a);
  }
  return col;
}

vec3 wallRoom(int t, vec2 p){
  vec4 s0 = surf(t, p);
  float h0 = s0.w, hx = surf(t, p + vec2(1.5, 0.0)).w, hy = surf(t, p + vec2(0.0, 1.5)).w;
  float k = bumpK(t);
  vec3 N = normalize(vec3(-(hx - h0) * k, -(hy - h0) * k, 1.0));
  vec3 Lk = normalize(vec3(-0.35, -0.55, 0.76));
  float E = max(dot(N, Lk), 0.0) * keyI(t);
  // the rail's soft shadow on the wall, thrown down and a little right by the key light
  float sy = uRail.z + uRailOff.y + uS * 0.05 + 2.0, sx = uRailOff.x + uS * 0.02;
  float soft = uRail.w * 2.2 + 5.0;
  float band = exp(-pow((p.y - sy) / soft, 2.0)) * smoothstep(uRail.x + sx - soft, uRail.x + sx + soft, p.x) * smoothstep(uRail.y + sx + soft, uRail.y + sx - soft, p.x);
  E *= 1.0 - 0.42 * band;
  float amb = ambient(t);
  vec2 uv = p / uRes;
  float vig = 1.0 - 0.24 * pow(length((uv - vec2(0.5, 0.42)) * vec2(1.0, 1.25)), 2.2);
  vec3 light = amb * vig * (1.0 - 0.08 * band) * vec3(0.97, 0.98, 1.0) + E * keyC(t) * (0.85 + 0.15 * N.z);
  vec3 col = s0.rgb * light;
  if (t == 2) col += vec3(0.85, 0.82, 0.78) * pow(max(dot(reflect(-Lk, N), vec3(0.0, 0.0, 1.0)), 0.0), 26.0) * 0.16;   // basalt sheen
  vec3 lf = amb * vig * vec3(0.97, 0.98, 1.0) + keyI(t) * 0.75 * keyC(t);    // flat light for things in front of the wall
  if (t == 7) col = sakura(p, col, lf);
  if (t == 8) col = garden(p, col, lf);
  return 1.0 - exp(-col * 1.85);                            // soft film shoulder
}

/* =============================== open rooms =============================== */
// ---- sky: cumulus on a perspective layer (horizon below the frame), lit from the upper left; faint cirrus above
vec2 skyPlane(vec2 p){
  float d = 1.0 / (1.75 - p.y / uRes.y);
  return vec2((p.x - uRes.x * 0.5) / uRes.y * d, d * 1.6);
}
float billow(vec2 q, int oct){
  float s = 0.0, a = 0.5;
  for (int i = 0; i < 5; i++){ if (i >= oct) break; s += a * abs(vn(q) * 2.0 - 1.0); q = q * 2.07 + vec2(13.7, 7.1); a *= 0.5; }
  return s;
}
float cloudField(vec2 s, float t, int oct){
  s.x -= t * 0.011;
  vec2 w = vec2(vn(s * 1.3 + vec2(0.0, t * 0.01)), vn(s * 1.3 + vec2(5.2, 1.3 - t * 0.008))) - 0.5;
  float banks = fbm3(s * 1.05 + vec2(1.7, 4.2));
  return banks * 1.15 + billow(s * 3.4 + w * 0.7, oct) * 0.6 - 0.5;
}
const float CLOUD_TH = 0.33;
vec3 skyColor(vec2 p){
  float W = uRes.x, H = uRes.y, t = uTime, y = p.y / H;
  vec3 zen = vec3(0.15, 0.38, 0.75), hor = vec3(0.66, 0.8, 0.93);
  vec3 col = mix(zen, hor, pow(smoothstep(-0.15, 1.2, y), 1.25));
  float sd = length(p - vec2(-0.12 * W, -0.4 * H)) / H;
  col += vec3(1.0, 0.95, 0.84) * 0.2 * exp(-sd * 1.7);
  vec2 c2 = vec2(p.x / H * 0.8 - t * 0.004, y * 3.0);
  float cir = smoothstep(0.56, 0.86, fbm3(c2 * vec2(1.3, 1.0) + vec2(0.0, fbm3(c2 * 1.9) * 0.7)));
  col = mix(col, vec3(0.96, 0.975, 1.0), cir * 0.28 * (1.0 - smoothstep(0.15, 0.75, y)));
  vec2 s = skyPlane(p);
  float f = cloudField(s, t, 5);
  float a = smoothstep(CLOUD_TH, CLOUD_TH + 0.045, f);
  if (a > 0.001) {
    float thick = smoothstep(CLOUD_TH, CLOUD_TH + 0.3, f);
    vec2 toSun = vec2(-0.03, -0.024);
    float occ = 0.0;
    for (int i = 1; i <= 3; i++) occ += max(cloudField(s + toSun * float(i), t, 3) - CLOUD_TH, 0.0);
    float light = exp(-occ * 3.2);
    vec3 cloud = mix(vec3(0.5, 0.57, 0.69), vec3(1.0, 0.985, 0.955), clamp(light + (1.0 - thick) * 0.45, 0.0, 1.0));
    cloud += vec3(1.0, 0.94, 0.82) * 0.1 * exp(-sd * 1.4) * light;
    float haze = smoothstep(0.5, 1.1, y);
    cloud = mix(cloud, hor * 1.04, haze * 0.5);
    col = mix(col, cloud, a * (1.0 - haze * 0.3));
  }
  return col;
}

// ---- forest: five layers of trunks and foliage receding into green haze, light shafts from the upper left
vec3 forestColor(vec2 p){
  float W = uRes.x, H = uRes.y, t = uTime, y = p.y / H, k = H / 860.0;
  vec3 col = mix(vec3(0.66, 0.75, 0.55), vec3(0.15, 0.23, 0.14), smoothstep(0.0, 0.95, y));
  col += vec3(1.0, 0.93, 0.7) * 0.32 * exp(-length((p - vec2(0.2 * W, -0.2 * H)) / vec2(W, H)) * 2.6);
  for (int L = 0; L < 5; L++){
    float fl = float(L), near = fl / 4.0, fog = 1.0 - near;
    vec3 fogC = mix(vec3(0.6, 0.7, 0.52), vec3(0.24, 0.34, 0.22), smoothstep(0.0, 1.0, y)) * (1.0 - 0.18 * near);
    float sway = sin(t * 0.35 + fl * 1.7) * (1.0 + 2.5 * near) * k;
    float xx = p.x + fl * 211.0 * k + sway * (1.0 - y) * 0.6;
    // trunks
    float sp = mix(64.0, 290.0, near) * k;
    float cell = floor(xx / sp), lx = xx - cell * sp;
    float r1 = h21(vec2(cell, fl + 3.1)), r2 = h21(vec2(cell, fl + 7.3)), r3 = h21(vec2(cell, fl + 11.9));
    float wT = mix(5.0, 50.0, near) * k * (0.6 + 0.8 * r2) * (0.85 + 0.35 * y);
    float dx = lx - sp * (0.2 + 0.6 * r1) - (r3 - 0.5) * 0.1 * (p.y - H);
    float trunk = smoothstep(wT * 0.5 + 0.9, wT * 0.5 - 0.9, abs(dx)) * step(0.2, r3 + 0.2 * near);
    float u = clamp(dx / max(wT * 0.5, 1.0), -1.0, 1.0);
    float barkN = vn(vec2(dx * 0.22 / k, p.y * 0.012 / k + cell * 3.0)) * 0.6 + vn(vec2(dx * 0.8 / k, p.y * 0.07 / k + cell)) * 0.4;
    vec3 bark = vec3(0.17, 0.14, 0.11) * (0.5 + 0.6 * (0.5 - 0.5 * u)) * (0.72 + 0.56 * barkN);
    bark = mix(bark, vec3(0.16, 0.24, 0.09) * (0.6 + 0.6 * barkN), smoothstep(0.55, 0.8, vn(vec2(dx * 0.08 / k, p.y * 0.01 / k + cell))) * 0.7);
    col = mix(col, mix(bark, fogC, fog * 0.86), trunk);
    // canopy hanging from above and undergrowth rising from below, with leafy edges
    float leafy = fbm(vec2(xx, p.y) * 0.032 / k + fl * 13.0 + vec2(t * 0.015, 0.0));
    float cl = (0.1 + 0.2 * near) * H + (fbm3(vec2(xx * 0.004 / k, fl * 3.0)) - 0.5) * 0.3 * H;
    float canopy = smoothstep(cl + 4.0 * k, cl - 4.0 * k, p.y + (leafy - 0.5) * 60.0 * k + (vn(vec2(xx, p.y) / (6.0 * k)) - 0.5) * 22.0 * k);
    float gl = H * (0.84 - 0.12 * near) - (fbm3(vec2(xx * 0.006 / k, fl * 5.0 + 2.0)) - 0.3) * 0.26 * H;
    float under = smoothstep(gl - 4.0 * k, gl + 4.0 * k, p.y - (leafy - 0.5) * 50.0 * k - (vn(vec2(xx, p.y) / (5.0 * k)) - 0.5) * 24.0 * k);
    // leaf-scale detail: individual leaves catch light or sit in shadow, with small gaps between them
    vec2 lp = vec2(xx, p.y) / ((4.0 + 5.0 * near) * k);
    float leaf = vn(lp + fl * 7.0) * 0.6 + vn(lp * 2.3 + 3.0) * 0.4;
    float gap = smoothstep(0.22, 0.12, leaf) * (1.0 - fog * 0.7);
    float fol = max(canopy, under) * (1.0 - gap * 0.85);
    vec3 leafC = mix(vec3(0.07, 0.17, 0.06), vec3(0.24, 0.4, 0.14), smoothstep(0.3, 0.8, leafy * 0.5 + leaf * 0.5));
    leafC *= 0.7 + 0.55 * smoothstep(0.35, 0.85, leaf);
    leafC += vec3(0.4, 0.45, 0.16) * smoothstep(0.72, 0.9, leaf) * smoothstep(0.45, 0.7, leafy) * (0.35 + 0.65 * near) * (1.0 - y);   // sunlit leaves
    col = mix(col, mix(leafC, fogC, fog * 0.8), fol);
  }
  float across = dot(p / H, normalize(vec2(0.88, -0.48)));
  float shaft = pow(fbm3(vec2(across * 7.0, t * 0.025)), 3.0) * 2.4 * smoothstep(1.05, 0.0, y);
  col += vec3(1.0, 0.94, 0.72) * shaft * 0.2;
  vec2 mg = vec2(p.x + t * 6.0 * k, p.y - t * 3.0 * k) / (26.0 * k);           // motes drifting in the light
  float mote = smoothstep(0.09, 0.0, length(fract(mg) - 0.5 - (vec2(h21(floor(mg)), h21(floor(mg) + 3.0)) - 0.5) * 0.6)) * step(0.88, h21(floor(mg) + 7.0));
  col += vec3(1.0, 0.95, 0.75) * mote * 0.6 * (0.3 + shaft);
  return col;
}

// ---- galaxy: a Milky-Way band with coloured nebulae and dust lanes, three sizes of stars, turning very slowly
vec3 starField(vec2 p, float t, float band){
  vec3 acc = vec3(0.0);
  for (int L = 0; L < 3; L++){
    float fl = float(L), cell = L == 0 ? 7.0 : L == 1 ? 23.0 : 71.0;
    vec2 g = p / cell + fl * 19.0, id = floor(g), f = fract(g) - 0.5;
    float h = h21(id + cell);
    float dens = L == 0 ? 0.18 + 0.5 * band : L == 1 ? 0.22 + 0.25 * band : 0.3;
    if (h > dens) continue;
    vec2 o = (vec2(h21(id + 3.1), h21(id + 7.7)) - 0.5) * 0.8;
    vec2 d = (f - o) * cell;
    float r = length(d), sz = L == 0 ? 0.7 : L == 1 ? 1.1 : 1.6;
    float tw = 0.7 + 0.3 * sin(t * (0.8 + 2.5 * h21(id + 9.0)) + h * 50.0);
    float b = smoothstep(sz, 0.0, r) + (L == 2 ? (exp(-abs(d.x) * 2.2) * exp(-abs(d.y) * 0.35) + exp(-abs(d.y) * 2.2) * exp(-abs(d.x) * 0.35)) * 0.25 : 0.0);
    vec3 c = mix(vec3(0.75, 0.85, 1.0), vec3(1.0, 0.85, 0.65), h21(id + 5.0));
    acc += c * b * tw * (0.45 + 0.75 * h21(id + 2.0)) * (L == 2 ? 1.6 : 1.15);
  }
  return acc;
}
vec3 galaxyColor(vec2 p){
  float H = uRes.y, t = uTime;
  vec2 q = rot(t * 0.003) * ((p - uRes * 0.5) / H);
  vec2 dir = normalize(vec2(1.0, -0.42));
  float along = dot(q, dir), across = dot(q, vec2(-dir.y, dir.x)) + 0.05 * sin(along * 2.3);
  float band = exp(-pow(across / 0.26, 2.0));
  vec2 w = vec2(fbm3(q * 1.6 + 3.0), fbm3(q * 1.6 + 8.0));
  float neb = fbm(q * 2.4 + w * 1.2);
  vec3 col = vec3(0.006, 0.008, 0.024);
  vec3 nebC = mix(vec3(0.36, 0.12, 0.5), vec3(0.06, 0.3, 0.55), smoothstep(0.3, 0.7, w.x));
  nebC = mix(nebC, vec3(0.75, 0.25, 0.35), smoothstep(0.6, 0.8, w.y) * 0.5);
  col += nebC * pow(neb, 1.8) * (0.32 + 2.1 * band);
  col += vec3(1.0, 0.82, 0.62) * exp(-pow(across / 0.085, 2.0)) * exp(-pow((along - 0.12) / 0.6, 2.0)) * 0.55;
  float dust = smoothstep(0.47, 0.72, fbm(vec2(along * 4.0, across * 11.0) + 21.0)) * band;
  col *= 1.0 - 0.8 * dust;
  col += starField(q * H, t, band) * (1.0 - 0.6 * dust);
  return col;
}

// ---- digital rain: columns of mirrored katakana falling, a bright head and a fading trail, two depths
vec3 matrixColor(vec2 p){
  float t = uTime, k = uRes.y / 860.0;
  vec3 col = vec3(0.0, 0.018, 0.008);
  for (int L = 0; L < 2; L++){
    float fl = float(L), cw = (L == 0 ? 11.0 : 17.0) * k, ch = cw * 1.3;
    vec2 g = vec2(p.x / cw + fl * 0.5, p.y / ch), id = floor(g), f = fract(g);
    float cs = h21(vec2(id.x, fl * 7.0 + 1.0));
    float speed = mix(5.0, 13.0, cs) * (L == 0 ? 0.65 : 1.0);
    float len = mix(8.0, 28.0, h21(vec2(id.x, 3.0 + fl)));
    float period = uRes.y / ch + len + 18.0 * cs;
    float headY = mod(t * speed + cs * period * 7.0, period);
    float dist = headY - id.y;
    float lit = step(0.0, dist) * step(dist, len);
    float gi = floor(h21(id + floor(t * (1.5 + 7.0 * h21(id + 1.7)))) * 64.0);
    vec2 a = vec2(mod(gi, 8.0), floor(gi / 8.0));
    float glyph = texture2D(uGlyphs, (a + vec2(f.x, 1.0 - f.y) * 0.86 + 0.07) / 8.0).a;   // no mipmaps: safe per cell
    float fade = pow(clamp(1.0 - dist / len, 0.0, 1.0), 1.5);
    vec3 gc = dist < 1.0 ? vec3(0.78, 1.0, 0.86) : vec3(0.1, 0.95, 0.38) * fade;
    col += gc * glyph * lit * (L == 0 ? 0.42 : 1.0);
    col += vec3(0.05, 0.6, 0.22) * lit * fade * 0.05 * (L == 0 ? 0.5 : 1.0);                   // glow of the column
  }
  return col * (0.93 + 0.07 * sin(p.y * uDpr * 1.6));                                          // faint scanlines
}

// ---- night of floating lanterns, drawn as 8-bit pixel art: dithered sky, pixel moon and stars, Mt Fuji, three depths
vec3 lanternSprite(vec2 s, out float a){
  // a 7 x 9 sprite; s is the sprite pixel relative to its centre
  a = 0.0; vec3 c = vec3(0.0);
  float x = abs(s.x), y = s.y;
  if (y == -4.0 && x <= 1.0) { a = 1.0; c = vec3(0.22, 0.08, 0.06); }
  else if ((y == -3.0 || y == 3.0) && x <= 2.0) { a = 1.0; c = vec3(0.45, 0.13, 0.07); }
  else if (y >= -2.0 && y <= 2.0 && x <= ((y == -2.0 || y == 2.0) ? 2.0 : 3.0)) {
    a = 1.0;
    c = mix(vec3(1.0, 0.82, 0.42), vec3(0.88, 0.38, 0.12), x / 3.0);
    if (x == 2.0 && abs(y) <= 1.0) c *= 0.72;                                   // the ribs
    if (x == 0.0 && y == 0.0) c = vec3(1.0, 0.95, 0.7);                        // flame
  }
  else if (y == 4.0 && x == 0.0) { a = 1.0; c = vec3(0.95, 0.65, 0.2); }       // tassel
  return c;
}
vec3 lanternColor(vec2 p){
  float W = uRes.x, H = uRes.y, t = uTime;
  float px = max(2.0, floor(H / 200.0));
  vec2 c = floor(p / px), q = (c + 0.5) * px;
  float y = q.y / H, dth = bayer4(c);
  float band = floor(clamp(y * 1.05, 0.0, 1.0) * 5.0 + dth * 0.999);
  vec3 col = mix(vec3(0.02, 0.02, 0.085), vec3(0.24, 0.1, 0.3), band / 5.0);
  float sh = h21(c);
  if (sh > 0.996 - 0.003 * (1.0 - y)) col = mix(col, vec3(0.95, 0.92, 0.8), (0.55 + 0.45 * step(0.5, sin(t * 1.6 + sh * 90.0))) * (1.0 - y));
  vec2 mc = W < 700.0 ? vec2(0.8 * W, 0.17 * H) : vec2(0.655 * W, 0.13 * H);
  float mr = (W < 700.0 ? 0.05 : 0.045) * H, md = length(q - mc);
  if (md < mr * 1.9 && dth < 0.25 * smoothstep(mr * 1.9, mr, md)) col += vec3(0.25, 0.22, 0.15);   // dithered halo
  if (md < mr) col = vec3(0.98, 0.94, 0.78) * (vn(c * 0.35) > 0.82 ? 0.86 : 1.0);
  // Fuji with a snow cap, then a dark ridge of hills in front
  float fx = 0.64 * W, peak = 0.6 * H, slope = abs(q.x - fx);
  float fujiTop = peak + slope * 0.42 - max(slope - 0.06 * W, 0.0) * 0.12;
  if (q.y > fujiTop) col = q.y < peak + 0.075 * H + (fbm3(vec2(q.x * 0.03, 1.0)) - 0.5) * 0.02 * H ? vec3(0.72, 0.74, 0.88) : vec3(0.09, 0.07, 0.17);
  float ridge = 0.86 * H - (fbm3(vec2(q.x * 0.004, 5.0)) - 0.5) * 0.12 * H;
  if (q.y > ridge) col = vec3(0.035, 0.03, 0.07);
  for (int L = 0; L < 3; L++){
    float fl = float(L), scale = fl + 1.0;
    float cell = (34.0 + 6.0 * fl) * scale * px;
    float speed = (5.0 + 3.0 * fl) * px * 0.5;
    vec2 g = vec2(q.x / cell, (q.y + t * speed) / cell) + fl * 17.0, id = floor(g), f = fract(g);
    if (h21(id + fl * 5.0) > 0.55 - 0.1 * fl) continue;
    vec2 o = vec2(0.25 + 0.5 * h21(id + 2.0), 0.25 + 0.5 * h21(id + 4.0));
    o.x += sin(t * 0.6 + h21(id) * 6.28) * 0.06;
    vec2 s = floor((f - o) * cell / (px * scale) + 0.5);
    float ga = 0.0;
    vec3 lc = lanternSprite(s, ga);
    float r = length(s);
    float glow = smoothstep(8.0, 2.5, r) * step(dth, 0.55 * smoothstep(8.0, 3.0, r));
    float depth = 1.0 - fl / 2.0;
    col += vec3(0.9, 0.45, 0.15) * glow * 0.22 * (1.0 - 0.5 * depth);
    lc = mix(lc, col, depth * 0.38);                                              // far lanterns fade into the night
    col = mix(col, lc, ga);
  }
  return col;
}

// ---- cracks where the brackets are bolted into an open room: fine radial fractures that kink and branch, a frosted
// crushed ring at the bolt, one faint concentric break, and each wedge nudged a pixel. Lines read dark on a bright
// scene and bright on a dark one, as real fracture faces do.
vec2 boltAt(float x){
  float D = uRes.y * 0.5 / 0.267949, f = D / (D + uRailDepth);
  return uRes * 0.5 + (vec2(x + uRailOff.x, uRail.z + uRailOff.y) - uRes * 0.5) * f;
}
float crackA(float a0, float r, float r0, float R, float fi, float seed){
  float u = max(r - r0, 0.0) / (R * 0.17), k = floor(u);
  return a0 + (mix(h21(vec2(k, fi + seed * 3.0)), h21(vec2(k + 1.0, fi + seed * 3.0)), u - k) - 0.5) * 0.3 * min(u, 1.0);
}
void fracture(vec2 p, vec2 c, float seed, inout float line, inout float lip, inout vec2 disp, inout float frost){
  vec2 d = p - c; float r = length(d);
  float R = uS * 0.3, r0 = uRail.w * 2.3;
  if (r > R) return;
  float th = atan(d.y, d.x);
  float bestDa = 10.0, wid = -1.0, aLo = 0.0, worstDa = -10.0, aHi = 0.0;
  for (int i = 0; i < 7; i++){
    float fi = float(i);
    float a0 = (fi + 0.5 + (h21(vec2(fi, seed)) - 0.5) * 0.8) / 7.0 * 6.28318 - 3.14159;
    float len = r0 + (R - r0) * (0.32 + 0.68 * h21(vec2(seed, fi + 4.0)));
    float a = crackA(a0, r, r0, R, fi, seed);
    float da = mod(th - a + 3.14159, 6.28318) - 3.14159, dist = abs(da) * r;
    float tp = clamp((r - r0) / (len - r0), 0.0, 1.0), w = mix(0.55, 0.1, tp);
    float on = (1.0 - smoothstep(0.82, 1.0, tp)) * step(r0 * 0.95, r);
    line = max(line, smoothstep(w + 0.45, w - 0.25, dist) * on);
    lip = max(lip, smoothstep(w + 1.2, w + 0.45, dist) * step(0.0, da) * on * (0.4 + 0.9 * vn(vec2(r * 0.18, fi + seed))));
    // a branch splits off part-way at a sharp angle and runs straight
    float rb = r0 + (len - r0) * (0.3 + 0.35 * h21(vec2(fi, seed + 8.0)));
    float ab = crackA(a0, rb, r0, R, fi, seed);
    vec2 B = c + rb * vec2(cos(ab), sin(ab));
    float side = h21(vec2(seed + 2.0, fi)) > 0.5 ? 1.0 : -1.0;
    vec2 E = B + (len - rb) * (0.35 + 0.3 * h21(vec2(fi, seed + 6.0))) * vec2(cos(ab + side * 0.6), sin(ab + side * 0.6));
    vec2 be = E - B; float tb = clamp(dot(p - B, be) / dot(be, be), 0.0, 1.0);
    float wb = mix(0.32, 0.06, tb);
    line = max(line, smoothstep(wb + 0.4, wb - 0.2, sdSeg(p, B, E)) * (1.0 - smoothstep(0.8, 1.0, tb)) * step(0.5, h21(vec2(fi, seed + 12.0)) + 0.3));
    if (r < len && da >= 0.0 && da < bestDa) { bestDa = da; wid = fi; aLo = a; }
    if (r < len && da < 0.0 && da > worstDa) { worstDa = da; aHi = a; }
  }
  if (wid >= 0.0) {
    float hw = 0.5 * mod(aHi - aLo + 6.28318, 6.28318), mid = aLo + hw;
    float off = mod(th - mid + 3.14159, 6.28318) - 3.14159;
    float rc = R * 0.36 * (0.9 + 0.2 * h21(vec2(wid, seed))) * cos(hw) / max(cos(off), 0.2) + (vn(vec2(th * 16.0, seed)) - 0.5) * 0.7;
    line = max(line, smoothstep(0.55, 0.05, abs(r - rc)) * step(0.55, h21(vec2(wid, seed + 1.0))) * step(hw, 1.2) * 0.5);
    disp += (vec2(h21(vec2(wid, seed + 9.0)), h21(vec2(seed + 3.0, wid))) - 0.5) * 2.0 * (1.0 - smoothstep(R * 0.12, R * 0.34, r));
  }
  frost = max(frost, smoothstep(r0 * 1.75, r0 * 1.02, r) * (0.45 + 0.55 * vn(d * 0.7 + seed)));
}
vec3 openColor(int t, vec2 p){
  if (t == 3) return forestColor(p);
  if (t == 4) return galaxyColor(p);
  if (t == 5) return matrixColor(p);
  if (t == 6) return lanternColor(p);
  return skyColor(p);
}
vec3 openRoom(int t, vec2 p){
  float line = 0.0, lip = 0.0, frost = 0.0; vec2 disp = vec2(0.0);
  fracture(p, boltAt(uRail.x), 1.7, line, lip, disp, frost);
  fracture(p, boltAt(uRail.y), 5.3, line, lip, disp, frost);
  vec3 col = openColor(t, p + disp);
  float bright = smoothstep(0.12, 0.42, lum(col));
  vec3 tint = t == 5 ? vec3(0.55, 1.0, 0.7) : t == 6 ? vec3(1.0, 0.86, 0.7) : t == 4 ? vec3(0.75, 0.82, 1.0) : vec3(0.9, 0.94, 1.0);
  col = mix(col, vec3(0.92, 0.95, 1.0), frost * 0.22);
  col = mix(col, tint, lip * mix(0.5, 0.35, bright) * (1.0 - line));
  vec3 lineC = mix(tint * 0.75, vec3(0.03, 0.04, 0.08), bright);
  return mix(col, lineC, line * 0.8) + (h21(p * 1.37) - 0.5) / 255.0;
}

vec3 room(int t, vec2 p){ return (t == 1 || t == 3 || t == 4 || t == 5 || t == 6) ? openRoom(t, p) : wallRoom(t, p); }

void main(){
  vec2 p = vec2(gl_FragCoord.x, uRes.y * uDpr - gl_FragCoord.y) / uDpr;
  vec3 c = room(uTheme, p);
  if (uMix < 1.0) {
    float rmax = length(uRes) * 1.05;
    float d = length(p - uReveal) - uMix * rmax;
    vec3 prev = room(uPrev, p);
    c = mix(c, prev, smoothstep(-30.0, 30.0, d));
    c += vec3(1.0, 0.82, 0.42) * exp(-pow(d / 14.0, 2.0)) * 0.55 * (1.0 - uMix);
  }
  gl_FragColor = vec4(c, 1.0);
}`
};

/* OTK_ARMORY(root, opts) mounts one rack into `root` (a .armory element) and returns its API, including destroy().
   opts: garments (packed list), decor (logos, peg rail, hats), room (default room index), roomKey (localStorage key for
   the visitor's chosen room; null = don't remember), newTab (open product links in a new tab, default true).
   Needs window.THREE (r128) and window.OTK_BACKDROP. */
window.OTK_ARMORY = function (root, opts) {
'use strict';
opts = opts || {};
const DATA = opts.garments || [];
if (!root || !window.THREE || !DATA.length) return null;

const $ = s => root.querySelector(s);
const rackCanvas = $('.armory__gl--rack'), liftCanvas = $('.armory__gl--lift');
const labelEl = $('.armory__label'), veil = $('.armory__veil');
const soundBtn = $('.armory__sound'), hintEl = $('.armory__hint'), a11yList = $('.armory__a11y');
const ui = { count: $('.armory__count'), name: $('.armory__name'), sub: $('.armory__sub'), cta: $('.armory__cta'), drag: $('.armory__drag'),
  close: $('.armory__close'), prev: $('.armory__nav--prev'), next: $('.armory__nav--next') };

const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
const COARSE = matchMedia('(hover: none)').matches;
if (COARSE && hintEl) hintEl.textContent = 'Tap a piece to turn it around. Tap again to take it off the rail. Swipe across the rail to brush through.';

const TAU = Math.PI * 2, HALF = Math.PI / 2;
const clamp = (v, a, b) => v < a ? a : v > b ? b : v;
const lerp = (a, b, t) => a + (b - a) * t;
const smooth = (a, b, x) => { const t = clamp((x - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); };
const price = p => '$' + (Math.round(parseFloat(p) * 100) % 100 === 0 ? parseFloat(p).toFixed(0) : parseFloat(p).toFixed(2));
const priceOf = d => d.available === false ? 'Sold out' : d.priceText || price(d.price);

/* ---------------- renderers ---------------- */
const FOV = 30;
const mkRenderer = c => { const r = new THREE.WebGLRenderer({ canvas: c, antialias: true, alpha: true, premultipliedAlpha: true, powerPreference: 'high-performance' });
  r.setPixelRatio(Math.min(window.devicePixelRatio || 1, COARSE ? 1.5 : 2)); r.setClearColor(0x000000, 0); return r; };
let renA, renB;
try { renA = mkRenderer(rackCanvas); renB = mkRenderer(liftCanvas); } catch (e) { if (renA) renA.dispose(); root.classList.add('is-nogl'); return null; }
const scene = new THREE.Scene();
const cam = new THREE.PerspectiveCamera(FOV, 1, 1, 10000);

/* ---------------- shaders ---------------- */
const VERT = `
uniform vec4 uRect; uniform float uBend, uYawMode, uZ, uMinW, uShadow, uSpread;
uniform vec2 uPivot, uView, uShadowOff; uniform float uPivotZ, uYawTop, uYawHem, uSwing, uHem, uPitch, uRipple, uTime, uShoulder, uHemY, uShear, uWallZ, uSeed;
varying vec2 vQ; varying float vT, vYaw, vRip;
void main(){
  vec2 e = vec2(uShadow * uSpread * 3.4);
  vec2 q = mix(uRect.xy - e, uRect.zw + e, vec2(uv.x, 1.0 - uv.y));
  vQ = q;
  float t = clamp((q.y - uShoulder) / max(1.0, uHemY - uShoulder), 0.0, 1.0);
  float tb = t * uBend;
  float yaw = mix(uYawTop, uYawHem, pow(tb, 1.25));
  vYaw = yaw; vT = t;
  vec3 p;
  if (uYawMode > 0.5 && uYawMode < 1.5) {
    float c = cos(yaw), s = sin(yaw);
    if (uMinW > 0.0) c = (c < 0.0 ? -1.0 : 1.0) * max(abs(c), uMinW);
    p = vec3(q.x * c, q.y, -q.x * s + uZ);
  } else if (uYawMode > 1.5) {
    float c = cos(yaw), s = sin(yaw);
    p = vec3(-q.x * s, q.y, -q.x * c + uZ);
  } else {
    p = vec3(q.x, q.y, uZ);
  }
  // resting drape: soft vertical folds that only read when the fabric turns
  float fold = sin(q.x * 0.045 + uSeed) * 0.012 * (uHemY - uShoulder) * tb;
  p.z += fold;
  float ph = uv.x * 7.0 + uTime * 7.5 + t * 4.5 + uSeed;
  p.z += uRipple * sin(ph) * tb;
  vRip = uRipple * cos(ph) * tb;
  float a = uSwing + (uHem - uSwing) * pow(tb, 1.6);
  float ca = cos(a), sa = sin(a);
  vec2 r = vec2(p.x * ca + p.y * sa, -p.x * sa + p.y * ca);
  float b = uPitch * (0.55 + 0.45 * tb);
  float y3 = r.y * cos(b);
  float z3 = p.z - r.y * sin(b);
  vec3 w = vec3(uPivot.x + r.x - uView.x * 0.5, uView.y * 0.5 - (uPivot.y + y3), uPivotZ + z3);
  if (uShadow > 0.5) { w.x += uShadowOff.x; w.y -= uShadowOff.y; w.z = uWallZ; }
  gl_Position = projectionMatrix * viewMatrix * vec4(w, 1.0);
}`;
const FRAG = `
uniform sampler2D uTexA, uTexB; uniform vec4 uRectA, uRectB; uniform float uMode, uAlpha, uShadow, uSpread, uWF, uWS, uHasSide, uYawMid; uniform vec2 uLight;
float faceVis(float yaw){ if (uHasSide < 0.5) return 1.0; float af = uWF * abs(cos(yaw)), as = uWS * abs(sin(yaw)); return step(0.5, af / (af + as + 0.001)); }
float hash(vec2 p){ p = floor(p); return fract(52.9829189 * fract(dot(p, vec2(0.06711056, 0.00583715)))); }
varying vec2 vQ; varying float vT, vYaw, vRip;
vec4 samp(sampler2D t, vec2 q, vec4 r, float bias){
  vec2 uv = (q - r.xy) / (r.zw - r.xy);
  // sample BEFORE the range test: inside a branch the mip level is undefined where a 2x2 pixel block straddles the
  // rect edge, and real GPUs (Apple/Metal) then read a tiny mip, drawing a faint line of the shirt's average colour
  // around every texture rect (the "rectangles"). Software GL never showed it.
  vec4 c = texture2D(t, vec2(uv.x, 1.0 - uv.y), bias);
  return (uv.x < 0.0 || uv.x > 1.0 || uv.y < 0.0 || uv.y > 1.0) ? vec4(0.0) : c;
}
void main(){
  if (uShadow > 0.5) {
    float acc = 0.0;
    float rot = hash(gl_FragCoord.xy) * 6.2832;
    for (int i = 0; i < 20; i++) {
      float fi = float(i) + 0.5;
      float an = fi * 2.39996 + rot; float rr = sqrt(fi / 20.0) * uSpread * 2.6;
      vec2 o = vec2(cos(an), sin(an)) * rr;
      if (uMode < 0.5) acc += max(samp(uTexA, vQ + o, uRectA, 3.0).a, samp(uTexB, vec2(-vQ.x, vQ.y) + o, uRectB, 3.0).a);
      else acc += samp(uTexA, vQ + o, uRectA, 3.0).a;
    }
    float a = acc / 20.0 * uAlpha; if (a < 0.003) discard; gl_FragColor = vec4(0.0, 0.0, 0.0, a); return;
  }
  float bias = 0.0;
  vec4 c; vec3 n = vec3(0.0, 0.0, 1.0);
  if (uMode < 0.5) {
    if (gl_FrontFacing) { c = samp(uTexA, vQ, uRectA, bias); n = vec3(sin(vYaw), 0.0, cos(vYaw)); }
    else { c = samp(uTexB, vec2(-vQ.x, vQ.y), uRectB, bias); n = -vec3(sin(vYaw), 0.0, cos(vYaw)); }
  } else if (uMode < 1.5) {
    n = vec3(cos(vYaw), 0.0, -sin(vYaw));
    if (gl_FrontFacing) c = samp(uTexA, vQ, uRectA, bias); else { c = samp(uTexB, vec2(-vQ.x, vQ.y), uRectB, bias); n = -n; }
  } else {
    c = samp(uTexA, vQ, uRectA, bias);
  }
  if (uMode < 1.5) { float fv = faceVis(uYawMid); float h = clamp(hash(gl_FragCoord.xy), 0.002, 0.998); if (uMode < 0.5 ? h > fv : h <= fv) discard; }
  n.x += vRip * 0.05; n = normalize(n);
  vec3 L = normalize(vec3(uLight.x, 0.55, 1.0));
  float diff = max(dot(n, L), 0.0);
  float shade = (0.58 + 0.46 * diff) * mix(1.04, 0.9, vT);
  if (uMode > 1.5) shade = 1.0;
  float a = c.a * uAlpha;
  if (a < 0.02) discard;
  gl_FragColor = vec4(c.rgb * shade * uAlpha, a);
}`;

const globals = { uView: { value: new THREE.Vector2(1, 1) }, uTime: { value: 0 }, uWallZ: { value: -46 }, uSpread: { value: 6 }, uOpen: { value: 0 },
  uEnvTop: { value: new THREE.Vector3(0.3, 0.5, 0.82) }, uEnvHor: { value: new THREE.Vector3(0.7, 0.82, 0.94) }, uEnvLow: { value: new THREE.Vector3(0.33, 0.35, 0.32) }, uEnvSun: { value: 1 } };

/* ---------------- textures ---------------- */
const loader = new THREE.TextureLoader();
let pending = 0;
const textures = [];
const loadTex = src => { pending++; const t = loader.load(src, () => { pending--; }, undefined, () => { pending--; }); textures.push(t);
  t.minFilter = THREE.LinearMipmapLinearFilter; t.magFilter = THREE.LinearFilter; t.generateMipmaps = true; t.anisotropy = 4; t.premultiplyAlpha = true; return t; };
const canvasTex = c => { const t = new THREE.CanvasTexture(c); t.minFilter = THREE.LinearMipmapLinearFilter; t.generateMipmaps = true; return t; };


/* ---------------- metal: hooks + rail are real 3D geometry ---------------- */
const METAL_VERT = `
uniform vec2 uPivot, uView, uRailOff; uniform float uPivotZ, uSwing, uPitch, uRail, uHookYaw;
varying vec3 vN; varying vec3 vP;
void main(){
  vec3 p = position; vec3 n = normal;
  vec3 w;
  if (uRail > 0.5) {
    w = vec3(p.x + uPivot.x - uView.x * 0.5 + uRailOff.x, uView.y * 0.5 - (uPivot.y + uRailOff.y) + p.y, p.z);
  } else {
    float ch = cos(uHookYaw), shh = sin(uHookYaw);
    p = vec3(p.x * ch + p.z * shh, p.y, -p.x * shh + p.z * ch);
    n = vec3(n.x * ch + n.z * shh, n.y, -n.x * shh + n.z * ch);
    float ca = cos(uSwing), sa = sin(uSwing);
    vec2 r = vec2(p.x * ca + p.y * sa, -p.x * sa + p.y * ca);
    vec2 rn = vec2(n.x * ca + n.y * sa, -n.x * sa + n.y * ca);
    float cb = cos(uPitch), sb = sin(uPitch);
    float y3 = r.y * cb + p.z * sb, z3 = p.z * cb - r.y * sb;
    float ny = rn.y * cb + n.z * sb, nz = n.z * cb - rn.y * sb;
    w = vec3(uPivot.x + r.x - uView.x * 0.5, uView.y * 0.5 - (uPivot.y + y3), uPivotZ + z3);
    n = vec3(rn.x, -ny, nz);
  }
  vN = n; vP = w;
  gl_Position = projectionMatrix * viewMatrix * vec4(w, 1.0);
}`;
const METAL_FRAG = `
uniform vec2 uLight; uniform vec3 uBase; uniform float uAlpha, uOpen, uEnvSun; uniform vec3 uEnvTop, uEnvHor, uEnvLow;
varying vec3 vN; varying vec3 vP;
vec3 env(vec3 r){
  // the room around the rack: bright ceiling + softbox above, limestone wall behind, a pale floor below
  float up = r.y;
  vec3 sky = mix(vec3(0.84, 0.85, 0.86), vec3(1.0), smoothstep(0.05, 0.7, up));
  vec3 floorC = mix(vec3(0.36, 0.35, 0.34), vec3(0.62, 0.61, 0.59), smoothstep(-1.0, -0.05, up));
  vec3 c = up > 0.0 ? sky : floorC;
  c = mix(c, vec3(0.80, 0.79, 0.76), smoothstep(0.0, -0.7, r.z) * (1.0 - smoothstep(0.35, 0.8, abs(up))));
  c -= vec3(0.28) * exp(-pow((up + 0.04) / 0.05, 2.0));                           // the dark seam under the horizon
  c += vec3(0.45) * exp(-pow((up - 0.04) / 0.03, 2.0));                           // crisp horizon highlight
  c += vec3(1.5) * exp(-pow((r.x - uLight.x * 0.5) / 0.22, 2.0) - pow((up - 0.55) / 0.2, 2.0)); // softbox
  // open rooms (no wall): the chrome mirrors that room's surroundings: sky above, its horizon, what lies below
  vec3 o = up > 0.0 ? mix(uEnvHor, uEnvTop, smoothstep(0.0, 0.75, up)) : mix(uEnvLow, uEnvHor, smoothstep(-1.0, -0.05, up));
  o += vec3(1.6) * uEnvSun * exp(-pow((r.x + 0.45) / 0.2, 2.0) - pow((up - 0.6) / 0.18, 2.0));   // the sun, upper left
  return mix(c, o, uOpen);
}
void main(){
  vec3 n = normalize(vN); if (!gl_FrontFacing) n = -n;
  vec3 V = vec3(0.0, 0.0, 1.0);
  vec3 R = reflect(-V, n);
  vec3 L = normalize(vec3(uLight.x, 0.8, 0.9));
  float spec = pow(max(dot(reflect(-L, n), V), 0.0), 120.0);
  float fres = 0.65 + 0.35 * pow(1.0 - max(n.z, 0.0), 2.0);
  vec3 col = env(R) * uBase * fres + vec3(1.0) * spec * 1.2;
  gl_FragColor = vec4(col * uAlpha, uAlpha);
}`;
let hookGeo = new THREE.BufferGeometry();
function mkMetal(sh, rail) {
  const u = { uPivot: sh ? sh.uPivot : { value: new THREE.Vector2() }, uPivotZ: sh ? sh.uPivotZ : { value: 0 }, uSwing: sh ? sh.uSwing : { value: 0 },
    uPitch: sh ? sh.uPitch : { value: 0 }, uLight: sh ? sh.uLight : { value: new THREE.Vector2() }, uView: globals.uView,
    uRailOff: { value: new THREE.Vector2() }, uRail: { value: rail ? 1 : 0 }, uHookYaw: sh ? sh.uHookYaw : { value: 0 }, uAlpha: { value: 1 }, uOpen: globals.uOpen, uEnvTop: globals.uEnvTop, uEnvHor: globals.uEnvHor, uEnvLow: globals.uEnvLow, uEnvSun: globals.uEnvSun,
    uBase: { value: rail ? new THREE.Color(0.93, 0.95, 0.98) : new THREE.Color(0.92, 0.94, 0.97) } };
  return new THREE.ShaderMaterial({ uniforms: u, vertexShader: METAL_VERT, fragmentShader: METAL_FRAG, transparent: false, side: THREE.DoubleSide });
}
const railMat = mkMetal(null, true);
const railMesh = new THREE.Mesh(new THREE.BufferGeometry(), railMat); railMesh.frustumCulled = false; railMesh.renderOrder = -50; scene.add(railMesh);
function buildMetal() {
  // hook: a wire that curls OVER the rail (front to back, tip hidden behind it) and drops into the collar
  const wire = Math.max(1.8, S * 0.0105), rr = (railRad + wire * 0.5 + 0.8) / Math.cos(0.26);
  const pts = [
    [0, rr * 0.75, -rr * 0.9], [0, 0, -rr], [0, -rr * 0.71, -rr * 0.71], [0, -rr, 0], [0, -rr * 0.71, rr * 0.71], [0, 0, rr],
    [0, rr * 1.5, rr * 0.85], [0, rr * 2.7, rr * 0.25], [0, hangDrop * 0.6, -0.5], [0, hangDrop + S * 0.004, -3.0]
  ].map(p => new THREE.Vector3(p[0], p[1], p[2]));
  const curve = new THREE.CatmullRomCurve3(pts, false, 'centripetal');
  const g = new THREE.TubeGeometry(curve, 64, wire / 2, 10, false);
  G.forEach(x => { if (x.parts && x.parts.hook) x.parts.hook.geometry = g; });
  if (hookGeo) hookGeo.dispose(); hookGeo = g;
  // rail: a real cylinder so the hook tip can pass behind it
  const len = (railR - railL) - railRad * 1.2;
  const cyl = new THREE.CylinderGeometry(railRad, railRad, len, 28, 1, false); cyl.rotateZ(Math.PI / 2);
  railMesh.geometry.dispose(); railMesh.geometry = cyl;
  railMat.uniforms.uPivot.value.set((railL + railR) / 2, railY);
}

/* ---------------- sizing ---------------- */
let W = 1, H = 1, S = 200, D = 1000, railY = 200, railL = 0, railR = 1, railRad = 5, hangDrop = 20, Lb = 100, spacing = 70, visibleN = DATA.length;

/* ---------------- garments ---------------- */
const shared = () => ({
  uPivot: { value: new THREE.Vector2() }, uPivotZ: { value: 0 }, uYawTop: { value: HALF }, uYawHem: { value: HALF },
  uSwing: { value: 0 }, uHem: { value: 0 }, uPitch: { value: 0 }, uRipple: { value: 0 }, uShoulder: { value: 0 }, uHemY: { value: 1 },
  uShear: { value: 0 }, uHookYaw: { value: 0.45 }, uWF: { value: 1 }, uWS: { value: 1 }, uYawMid: { value: HALF }, uHasSide: { value: 1 }, uLight: { value: new THREE.Vector2(0, 0) }, uShadowOff: { value: new THREE.Vector2(8, 20) }, uSeed: { value: Math.random() * 6 }
});
const geoBend = new THREE.PlaneGeometry(1, 1, 14, 26), geoFlat = new THREE.PlaneGeometry(1, 1, 1, 1);
function mkMat(sh, o) {
  const u = Object.assign({}, sh, globals, {
    uRect: { value: new THREE.Vector4() }, uRectA: { value: new THREE.Vector4() }, uRectB: { value: new THREE.Vector4() },
    uTexA: { value: o.texA || null }, uTexB: { value: o.texB || null }, uMode: { value: o.mode }, uAlpha: { value: 1 },
    uShadow: { value: o.shadow ? 1 : 0 }, uBend: { value: o.bend ? 1 : 0 }, uYawMode: { value: o.yaw === 'side' ? 2 : o.yaw ? 1 : -1 }, uZ: { value: o.z || 0 }, uMinW: { value: o.minW || 0 }
  });
  const m = new THREE.ShaderMaterial({ uniforms: u, vertexShader: VERT, fragmentShader: FRAG, transparent: true, premultipliedAlpha: true,
    depthWrite: !o.shadow, depthTest: true, side: o.mode === 0 ? THREE.DoubleSide : THREE.DoubleSide });
  return m;
}

const G = DATA.map((d, i) => {
  const sh = shared();
  const v = d.views, heroBack = d.hero === 'back';
  const front = v.front, back = v.back || v.front, side = v.side || null, sideR = v.sideR || v.side || null;
  const texF = loadTex(front.src), texB = v.back ? loadTex(back.src) : texF, texS = side ? loadTex(side.src) : null, texSR = v.sideR ? loadTex(v.sideR.src) : texS;
  const parts = {};
  parts.shadowFace = new THREE.Mesh(geoBend, mkMat(sh, { mode: 0, texA: texF, texB: texB, shadow: true, bend: true, yaw: true }));
  if (side) parts.shadowSide = new THREE.Mesh(geoBend, mkMat(sh, { mode: 1, texA: texS, texB: texSR, shadow: true, bend: true, yaw: 'side' }));
  parts.face = new THREE.Mesh(geoBend, mkMat(sh, { mode: 0, texA: texF, texB: texB, bend: true, yaw: true, z: i * 0.55 }));
  if (side) parts.side = new THREE.Mesh(geoBend, mkMat(sh, { mode: 1, texA: texS, texB: texSR, bend: true, yaw: 'side', z: i * 0.55 }));
  parts.hook = new THREE.Mesh(hookGeo, mkMetal(sh));
  sh.uHasSide.value = side ? 1 : 0;
  Object.values(parts).forEach(m => { m.frustumCulled = false; scene.add(m); });
  const restYaw = side ? -HALF + (Math.random() - 0.5) * 0.06 : (heroBack ? Math.PI - 1.3 : 1.3);
  const [name, sub] = d.display || [d.title, ''];
  return {
    i, d, name, sub, sh, parts, side: !!side, heroYaw: heroBack ? Math.PI : 0, restYaw,
    x: 0, vx: 0, ax: 0, tx: 0, y: -400, vy: 0, z: 0, vz: 0, zJit: 0,
    hookYaw: (i % 2 ? 1 : -1) * (0.17 + Math.random() * 0.07), hookYawV: 0, hookRest: 0, yaw: restYaw, yawV: 0, yawH: restYaw, yawHV: 0, yawTarget: restYaw,
    phi: (Math.random() - 0.5) * 0.02, phiV: 0, hem: 0, hemV: 0, pitch: 0, pitchV: 0, rip: 0, torque: 0,
    state: 'wait', delay: 0, layer: 0, wF: 1, wS: 1, liftT: 0, flightT: 0, visible: true, lastClink: 0, sideA: 1, faceA: 0,
    rects: { front, back, side, sideR: v.sideR || side }
  };
});

function layoutMetrics() {
  const r = root.getBoundingClientRect(); W = Math.max(320, r.width); H = Math.max(480, r.height);
  visibleN = W < 640 ? Math.min(5, G.length) : W < 980 ? Math.min(8, G.length) : G.length;
  const railLen = Math.min(W * (W < 640 ? 0.92 : 0.8), 1500);
  const headEl = $('.armory__head'), headB = headEl.offsetTop + headEl.offsetHeight;
  layoutRacks();
  const shelfEl = $('.armory__rack--l'), shelfB = (W > 760 && shelfEl) ? shelfEl.offsetTop + shelfEl.offsetHeight + 20 : 0;
  railY = Math.max(H * (W < 640 ? 0.36 : 0.33), headB + 40, shelfB + 36);
  const pack = W < 640 ? 0.36 : 0.385;
  const sW = railLen / (visibleN * pack + (W < 640 ? 1.05 : 0.85));
  const sH = (H - railY - 150) / 1.08;
  S = Math.max(70, Math.min(sW, sH, 420));
  hangDrop = S * 0.1; Lb = S * 0.5; spacing = S * pack;
  railRad = clamp(S * 0.018, 3.5, 7.5);
  const usedLen = Math.min(railLen, visibleN * spacing + S * 1.1);
  railL = W / 2 - usedLen / 2; railR = W / 2 + usedLen / 2;
  D = (H / 2) / Math.tan((FOV / 2) * Math.PI / 180);
  cam.aspect = W / H; cam.position.set(0, 0, D); cam.near = 10; cam.far = D * 4; cam.updateProjectionMatrix();
  renA.setSize(W, H, false); renB.setSize(W, H, false);
  globals.uView.value.set(W, H); globals.uSpread.value = Math.max(4, S * 0.04); globals.uWallZ.value = -Math.max(30, S * 0.17);
  layoutDecor();
  buildMetal();
  layoutDecor(); buildBrackets();
  G.forEach(g => {
    g.visible = g.i < visibleN;
    const f = g.rects.front, b = g.rects.back, s = g.rects.side;
    const rectOf = v => [(v.bb[0] - v.neck) * S, hangDrop, (v.bb[2] - v.neck) * S, hangDrop + (v.bb[3] - v.bb[1]) * S];
    const rf = rectOf(f), rb = rectOf(b);
    const union = [Math.min(rf[0], -rb[2]), hangDrop, Math.max(rf[2], -rb[0]), Math.max(rf[3], rb[3])];
    g.wF = (f.bb[2] - f.bb[0]) * S; g.h = (f.bb[3] - f.bb[1]) * S;
    g.wS = s ? (s.bb[2] - s.bb[0]) * S : 0;
    const set = (m, rect, a, b2) => { if (!m) return; const u = m.material.uniforms; u.uRect.value.set(...rect); u.uRectA.value.set(...(a || rect)); u.uRectB.value.set(...(b2 || rect)); };
    set(g.parts.face, union, rf, rb); set(g.parts.shadowFace, union, rf, rb);
    if (s) { const rs = rectOf(s), rr = rectOf(g.rects.sideR); set(g.parts.side, rs, rs, rr); set(g.parts.shadowSide, rs, rs, rr); }
    g.sh.uWF.value = g.wF; g.sh.uWS.value = g.wS || 1;
    g.sh.uShoulder.value = hangDrop + S * 0.13; g.sh.uHemY.value = hangDrop + g.h; g.sh.uShear.value = S * 0.12;
  });
  // place garments at their rest slots
  const vis = G.filter(g => g.visible);
  vis.forEach((g, k) => { const x = W / 2 + (k - (vis.length - 1) / 2) * spacing; g.rest = x; if (g.state === 'hung' || g.state === 'wait') { g.x = x; g.tx = x; } });
  if (!introDone && !REDUCED) G.forEach(g => { if (g.state === 'wait') g.y = railY - S * 1.4 - 160; });
  title.prepare();
}

/* ---------------- sound ---------------- */
const Sound = {
  ctx: null, on: false, slideGain: null, swishGain: null,
  init() {
    if (this.ctx) return; const AC = window.AudioContext || window.webkitAudioContext; if (!AC) return;
    const ctx = this.ctx = new AC(); const len = ctx.sampleRate * 2, buf = ctx.createBuffer(1, len, ctx.sampleRate), d = buf.getChannelData(0);
    for (let i = 0; i < len; i++) d[i] = Math.random() * 2 - 1;
    this.noise = buf; this.master = ctx.createGain(); this.master.gain.value = 0.9; this.master.connect(ctx.destination);
    const mkLoop = (type, f, q) => { const src = ctx.createBufferSource(); src.buffer = buf; src.loop = true; const fl = ctx.createBiquadFilter(); fl.type = type; fl.frequency.value = f; fl.Q.value = q;
      const g = ctx.createGain(); g.gain.value = 0; src.connect(fl).connect(g).connect(this.master); src.start(); return g; };
    this.slideGain = mkLoop('bandpass', 3400, 1.4); this.swishGain = mkLoop('lowpass', 700, 0.5);
  },
  clink(v) {
    if (!this.on || !this.ctx) return; const ctx = this.ctx, t = ctx.currentTime, k = 0.9 + Math.random() * 0.25;
    [[2350, 1, .26], [3720, .55, .17], [5480, .35, .1], [7900, .18, .06]].forEach(([f, a, dec]) => {
      const o = ctx.createOscillator(), g = ctx.createGain(); o.frequency.value = f * k; o.type = 'sine';
      g.gain.setValueAtTime(0, t); g.gain.linearRampToValueAtTime(0.09 * a * v, t + 0.002); g.gain.exponentialRampToValueAtTime(0.0001, t + dec);
      o.connect(g).connect(this.master); o.start(t); o.stop(t + dec + 0.02);
    });
  },
  thud(v) {
    if (!this.on || !this.ctx) return; const ctx = this.ctx, t = ctx.currentTime;
    const s = ctx.createBufferSource(); s.buffer = this.noise; const f = ctx.createBiquadFilter(); f.type = 'lowpass'; f.frequency.value = 420; const g = ctx.createGain();
    g.gain.setValueAtTime(0.25 * v, t); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.14); s.connect(f).connect(g).connect(this.master); s.start(t); s.stop(t + 0.16);
  },
  update(slide, swish) {
    if (!this.ctx) return; const t = this.ctx.currentTime;
    this.slideGain.gain.setTargetAtTime(this.on ? clamp(slide, 0, 1) * 0.05 : 0, t, 0.05);
    this.swishGain.gain.setTargetAtTime(this.on ? clamp(swish, 0, 1) * 0.12 : 0, t, 0.06);
  }
};
if (soundBtn) soundBtn.addEventListener('click', () => {
  Sound.init(); Sound.on = !Sound.on; if (Sound.ctx && Sound.ctx.state === 'suspended') Sound.ctx.resume();
  soundBtn.setAttribute('aria-pressed', String(Sound.on)); soundBtn.querySelector('span').textContent = Sound.on ? 'Sound on' : 'Sound off';
  soundBtn.querySelector('.w').setAttribute('opacity', Sound.on ? '1' : '.25'); if (Sound.on) Sound.clink(0.8);
});

/* ---------------- interaction state ---------------- */
const P = { x: -9999, y: -9999, vx: 0, vy: 0, inside: false, t: 0, down: false, type: 'mouse' };
let focus = -1, kbdFocus = false, unfocusTimer = 0, lifted = -1, introDone = false, running = false, lightX = 0, rail = { ox: 0, ov: 0, oy: 0, oyv: 0, ax: 0, grab: false, gx: 0 };
let viewerDrag = null, dragHintGone = false, tapStart = null;

function bodyRect(g) {
  const w = Math.max(g.wv || g.wS || g.wF * 0.4, S * 0.18);
  const cx = g.x + rail.ox + Math.sin(g.phi) * Lb * 0.6;
  return { l: cx - w / 2, r: cx + w / 2, t: g.y + hangDrop, b: g.y + hangDrop + g.h, cx };
}
function pick(px, py) {
  let best = -1, bd = 1e9;
  for (const g of G) {
    if (!g.visible || g.state === 'lift' || g.state === 'return' || g.state === 'wait') continue;
    const r = bodyRect(g), pad = g.i === focus ? 14 : 0;
    if (px >= r.l - pad && px <= r.r + pad && py >= r.t - pad - hangDrop && py <= r.b + pad) {
      const d = Math.abs(px - r.cx) - (g.i === focus ? 1e4 : 0); if (d < bd) { bd = d; best = g.i; }
    }
  }
  return best;
}
function inRackBand(px, py) { return px > railL - 30 && px < railR + 30 && py > railY - 30 && py < railY + hangDrop + S * 1.02 + 20; }
function setFocus(i, viaKbd = false) {
  if (i === focus) { kbdFocus = viaKbd; return; }
  const prev = G[focus]; focus = i; kbdFocus = viaKbd;
  if (prev) { prev.pitchV += REDUCED ? 0 : 0.35; }
  const g = G[i];
  if (g) { g.pitchV += REDUCED ? 0 : -0.55; g.phiV += REDUCED ? 0 : (Math.random() - 0.5) * 0.4;
    labelEl.querySelector('b').textContent = g.name;
    labelEl.querySelector('span').innerHTML = '';
    const sp = labelEl.querySelector('span'); sp.append(g.d.color || ''); const em = document.createElement('em'); em.textContent = priceOf(g.d); sp.append(em);
    if (Sound.on) Sound.clink(0.35);
  }
}

function localXY(e) { const r = root.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; }
root.addEventListener('pointermove', e => {
  const [x, y] = localXY(e), now = performance.now(), dt = Math.max(8, now - P.t) / 1000;
  if (P.t && P.inside) { P.vx = lerp(P.vx, (x - P.x) / dt, 0.5); P.vy = lerp(P.vy, (y - P.y) / dt, 0.5); }
  P.x = x; P.y = y; P.t = now; P.inside = true; P.type = e.pointerType;
  if (viewerDrag) {
    const dx = x - viewerDrag.x0; const g = G[lifted];
    if (g) { g.yawTarget = viewerDrag.y0 + dx * 0.0105; viewerDrag.v = lerp(viewerDrag.v, (x - viewerDrag.lx) / dt * 0.0105, 0.4); viewerDrag.lx = x; }
    if (!dragHintGone && Math.abs(dx) > 30) { dragHintGone = true; ui.drag.classList.add('is-gone'); }
    return;
  }
  if (rail.grab) { rail.gx = x; return; }
  if (lifted >= 0) return;
  if (e.pointerType === 'touch') return; // touch brushes but doesn't change focus
  const hit = pick(x, y);
  const nearRail = Math.abs(y - railY) < railRad + 10 && x > railL && x < railR;
  rackCanvas.style.cursor = hit >= 0 ? 'pointer' : nearRail ? 'grab' : 'default';
  if (hit >= 0) { clearTimeout(unfocusTimer); unfocusTimer = 0; setFocus(hit); }
  else if (!inRackBand(x, y)) { if (focus >= 0 && !unfocusTimer) unfocusTimer = setTimeout(() => { setFocus(-1); unfocusTimer = 0; }, 140); }
}, { passive: true });
// a lifted finger always "leaves"; on touch, focus is cleared by tapping the wall instead (endPointer)
root.addEventListener('pointerleave', e => { P.inside = false; P.vx = P.vy = 0; if (lifted < 0 && !kbdFocus && e.pointerType !== 'touch') setFocus(-1); });

rackCanvas.addEventListener('pointerdown', e => {
  const [x, y] = localXY(e); P.x = x; P.y = y; P.t = performance.now(); P.down = true; P.type = e.pointerType;
  if (Math.abs(y - railY) < railRad + 10 && x > railL && x < railR && e.pointerType !== 'touch') {
    rail.grab = true; rail.g0 = x; rail.gx = x; rackCanvas.setPointerCapture(e.pointerId); rackCanvas.style.cursor = 'grabbing'; return;
  }
  tapStart = { x, y, t: performance.now() };
});
const endPointer = e => {
  P.down = false;
  if (rail.grab) { rail.grab = false; rackCanvas.style.cursor = 'grab'; return; }
  if (!tapStart) return; const [x, y] = localXY(e); const moved = Math.hypot(x - tapStart.x, y - tapStart.y), dt = performance.now() - tapStart.t; tapStart = null;
  if (moved > 12 || dt > 600 || lifted >= 0) return;
  const hit = pick(x, y);
  if (hit < 0) { if (e.pointerType === 'touch') setFocus(-1); return; }
  if (e.pointerType === 'touch' && hit !== focus) { setFocus(hit); return; }
  openViewer(hit, 0, false);
};
rackCanvas.addEventListener('pointerup', endPointer);
rackCanvas.addEventListener('pointercancel', () => { tapStart = null; rail.grab = false; P.down = false; });

veil.addEventListener('pointerdown', e => { if (lifted < 0) return; const [x] = localXY(e); const g = G[lifted];
  viewerDrag = { x0: x, lx: x, y0: g.yawTarget, v: 0 }; veil.setPointerCapture(e.pointerId); veil.classList.add('is-dragging'); });
const endViewerDrag = () => { if (!viewerDrag) return; const g = G[lifted];
  if (g) { const proj = g.yawTarget + clamp(viewerDrag.v, -12, 12) * 0.18; g.yawTarget = Math.round((proj - g.heroYaw) / Math.PI) * Math.PI + g.heroYaw; }
  viewerDrag = null; veil.classList.remove('is-dragging'); };
veil.addEventListener('pointerup', endViewerDrag); veil.addEventListener('pointercancel', endViewerDrag);

/* ---------------- viewer ---------------- */
let returnFocusTo = null;
function viewerTarget(g) {
  const want = Math.min(H * (W < 640 ? 0.42 : 0.5), (W * 0.62) / (g.wF / g.h));
  const scale = want / g.h, z = D * (1 - 1 / scale);
  const screenPivotY = H * (W < 640 ? 0.36 : 0.39) - (hangDrop + g.h / 2) * scale;
  return { x: W / 2, y: H / 2 + (screenPivotY - H / 2) / scale, z, scale };
}
let openedByKbd = false;
function openViewer(i, dir = 0, kbd = openedByKbd) {
  openedByKbd = kbd;
  const g = G[i]; if (!g || g.state === 'wait') return;
  if (lifted >= 0 && lifted !== i) returnGarment(G[lifted]);
  lifted = i; returnFocusTo = returnFocusTo || document.activeElement;
  setFocus(-1); clearTimeout(unfocusTimer);
  g.state = 'lift'; g.flightT = 0; g.layer = 1; setLayer(g, 1);
  g.x += rail.ox; // detach from rail motion
  g.yawTarget = nearestEquiv(g.heroYaw, g.yaw);
  g.vy -= REDUCED ? 0 : 260; // the little tug upward as it leaves the hook
  if (dir) g.vx += dir * -200;
  root.classList.add('is-open');
  ui.count.textContent = `${visIndex(g) + 1} of ${G.filter(x => x.visible).length}`;
  ui.name.textContent = g.name;
  ui.sub.textContent = ''; ui.sub.append(`${g.sub}${g.d.color ? ', ' + g.d.color.toLowerCase() : ''}`); const em = document.createElement('em'); em.textContent = priceOf(g.d); ui.sub.append(em);
  ui.cta.href = g.d.url;
  if (Sound.on) { Sound.clink(0.7); }
  if (kbd) setTimeout(() => { if (lifted === i) ui.close.focus({ preventScroll: true }); }, 50);
  const r = root.getBoundingClientRect(); if (r.top < -20 || r.bottom > innerHeight + 20) root.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' });
}
function returnGarment(g) { g.state = 'return'; g.flightT = 0; g.yawTarget = nearestEquiv(g.restYaw, g.yaw); }
function closeViewer() {
  if (lifted < 0) return; returnGarment(G[lifted]); lifted = -1; root.classList.remove('is-open'); openedByKbd = false;
  const back = returnFocusTo; returnFocusTo = null; if (back && back.focus && root.contains(back)) back.focus({ preventScroll: true });
}
function step(dir) {
  const vis = G.filter(g => g.visible); if (lifted < 0) return;
  const k = (visIndex(G[lifted]) + dir + vis.length) % vis.length; openViewer(vis[k].i, dir);
}
const visIndex = g => G.filter(x => x.visible).indexOf(g);
const nearestEquiv = (target, current) => target + Math.round((current - target) / TAU) * TAU;
ui.close.addEventListener('click', closeViewer); ui.prev.addEventListener('click', () => step(-1)); ui.next.addEventListener('click', () => step(1));
const onKey = e => {
  if (lifted < 0) return;
  if (e.key === 'Escape') { e.preventDefault(); closeViewer(); }
  else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
  else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
};
document.addEventListener('keydown', onKey);
if (opts.newTab === false) ui.cta.removeAttribute('target');
function setLayer(g, l) { Object.values(g.parts).forEach(m => m.layers.set(l)); }

/* keyboard / screen reader list */
a11yList.textContent = '';
G.forEach(g => { const li = document.createElement('li'); const b = document.createElement('button'); b.type = 'button';
  b.textContent = `${g.name}, ${g.sub}, ${g.d.color || ''}, ${priceOf(g.d)}. Open details`;
  b.addEventListener('focus', () => { if (lifted < 0) setFocus(g.i, true); });
  b.addEventListener('blur', () => { if (lifted < 0 && kbdFocus) { kbdFocus = false; setFocus(-1); } });
  b.addEventListener('click', () => { returnFocusTo = b; openViewer(g.i, 0, true); });
  g.btn = b; li.append(b); a11yList.append(li); });

/* ---------------- physics ---------------- */
const K = REDUCED
  ? { hook: 260, hookC: 32, yaw: 150, yawC: 25, hemY: 90, hemYC: 19, w0: 30, phiC: 9, hemS: 80, hemSC: 18, pitch: 42, pitchC: 13, brush: 0, breeze: 0 }
  : { hook: 230, hookC: 21, yaw: 150, yawC: 14.5, hemY: 95, hemYC: 7.5, w0: 30, phiC: 2.2, hemS: 62, hemSC: 3.8, pitch: 42, pitchC: 3.2, brush: 1.15, breeze: 0.16 };

function solveTargets() {
  const items = G.filter(g => g.visible && g.state !== 'lift');
  items.sort((a, b) => a.rest - b.rest);
  const xs = items.map(g => g.rest);
  const width = g => g.side ? Math.max(g.wF * Math.abs(Math.cos(g.yaw)), g.wS * Math.abs(Math.sin(g.yaw))) : g.wF * Math.max(0.36, Math.abs(Math.cos(g.yaw)));
  items.forEach(g => { g.wv = width(g); g.open = Math.abs(Math.cos(g.yaw)) * (g.side ? 1 : 0.7); });
  // when a piece is off the rail, its neighbours drift into the gap
  const gone = G.find(g => g.visible && g.state === 'lift');
  if (gone) { const n = items.length; items.forEach((g, k) => { xs[k] = W / 2 + (k - (n - 1) / 2) * spacing * (n + 1) / n * 0.98; }); }
  const em = W < 640 ? 0.17 : 0.06, lo = railL + S * em, hi = railR - S * em;
  for (let it = 0; it < 18; it++) {
    for (let k = 0; k < items.length - 1; k++) {
      const a = items[k], b = items[k + 1];
      const pk = lerp(0.84, 1.05, Math.max(a.open, b.open));
      const dmin = 0.5 * (a.wv + b.wv) * pk;
      const d = xs[k + 1] - xs[k];
      if (d < dmin) {
        const ma = a.i === focus ? 0.12 : 1, mb = b.i === focus ? 0.12 : 1, c = dmin - d;
        xs[k] -= c * ma / (ma + mb); xs[k + 1] += c * mb / (ma + mb);
      }
    }
    for (let k = 0; k < xs.length; k++) xs[k] = clamp(xs[k], lo, hi);
  }
  items.forEach((g, k) => g.tx = xs[k]);
  return items;
}


/* Soft fabric contact between neighbours, tested at chest and hem height.
   The contact width is narrower than the drawn width (sleeves and drape compress), restitution is low so the
   bump is absorbed like cloth, and a little momentum goes into the neighbour's hook so it slides along the rail. */
const CONTACT = { width: 0.9, e: 0.12, push: 0.35, hook: 0.12, heights: [0.5, 1.0] };
function bodyAt(g, t) {
  const y = hangDrop + t * g.h, w = Math.pow(t, 1.6);
  const ang = g.phi + (g.hem - g.phi) * w, angV = g.phiV + (g.hemV - g.phiV) * w;
  return { x: g.x + y * Math.sin(ang), v: g.vx + y * Math.cos(ang) * angV, y, w, c: Math.cos(ang) };
}
function collide(a, b) {
  if (REDUCED) return;
  const d0 = CONTACT.width * 0.5 * (a.wv + b.wv);
  for (const t of CONTACT.heights) {
    const A = bodyAt(a, t), B = bodyAt(b, t);
    const pen = d0 - (B.x - A.x);
    if (pen <= 0) continue;
    const vrel = B.v - A.v;
    if (vrel < 0) {
      const dv = -(1 + CONTACT.e) * vrel * 0.5;           // each side takes half the change
      const dwA = dv / (A.y * Math.max(0.3, A.c)), dwB = dv / (B.y * Math.max(0.3, B.c));
      // the hem is the part that touches first, so split the response between body swing and hem lag
      a.phiV -= dwA * (1 - 0.6 * A.w); a.hemV -= dwA * (1 + 0.4 * A.w);
      b.phiV += dwB * (1 - 0.6 * B.w); b.hemV += dwB * (1 + 0.4 * B.w);
      a.vx -= dv * CONTACT.hook; b.vx += dv * CONTACT.hook;
      if (-vrel > 160 && Sound.on) Sound.thud(clamp(-vrel / 4000, 0.03, 0.12));
    }
    // ease them apart (fabric squash), never a hard snap
    const corr = pen * CONTACT.push * 0.5;
    a.phi -= corr / A.y * (1 - 0.5 * A.w); a.hem -= corr / A.y;
    b.phi += corr / B.y * (1 - 0.5 * B.w); b.hem += corr / B.y;
  }
}

let clinkBudget = 0;
function physics(dt, t) {
  const items = solveTargets();
  // rail spring (grab + ring)
  const railTarget = rail.grab ? clamp((rail.gx - rail.g0) * 0.4, -S * 0.32, S * 0.32) : 0;
  const prevOV = rail.ov;
  rail.ov += ((rail.grab ? 520 : 240) * (railTarget - rail.ox) - (rail.grab ? 40 : 7) * rail.ov) * dt;
  rail.ox += rail.ov * dt; rail.ax = (rail.ov - prevOV) / dt;
  rail.oyv += (-2400 * rail.oy - 9 * rail.oyv) * dt; rail.oy += rail.oyv * dt;
  const railYNow = railY + rail.oy;

  // brushing: the cursor moving through fabric
  const pv = Math.hypot(P.vx, P.vy);
  P.vx *= Math.pow(0.0008, dt); P.vy *= Math.pow(0.0008, dt);

  let slideAcc = 0, swishAcc = 0;
  for (const g of G) {
    if (!g.visible) continue;
    let ax = 0, ay = 0;
    const L = Lb;
    // --- hook / flight translation
    if (g.state === 'hung' || g.state === 'drop' || g.state === 'intro') {
      const prevV = g.vx;
      g.vx += (K.hook * (g.tx - g.x) - K.hookC * g.vx) * dt;
      g.x += g.vx * dt; ax = (g.vx - prevV) / dt + rail.ax;
      slideAcc += Math.abs(g.vx);
      if (g.state === 'hung') { g.y = railYNow; g.vy = 0; }
      else {
        if (t < g.delay) { g.y = railY - S * 1.4 - 160; }
        else {
          g.vy += 2900 * dt; g.y += g.vy * dt; ay = 2900;
          if (g.y >= railYNow) {
            g.y = railYNow;
            if (g.vy > 140) { const v = g.vy; Sound.clink(clamp(v / 1400, 0.25, 1)); Sound.thud(clamp(v / 2200, 0.1, .6)); rail.oyv += v * 0.006; g.phiV += (Math.random() - 0.5) * (REDUCED ? 0 : 2.2); g.pitchV += REDUCED ? 0 : 0.6; g.vy = -v * 0.18; }
            else { g.vy = 0; g.state = 'hung'; }
          }
        }
      }
      g.z += (g.zJit - g.z) * Math.min(1, dt * 6); g.vz = 0;
    } else if (g.state === 'lift' || g.state === 'return') {
      g.flightT += dt;
      let T;
      if (g.state === 'lift') T = viewerTarget(g);
      else T = { x: g.tx + rail.ox, y: railYNow - S * 0.22, z: g.zJit };
      const k = g.state === 'lift' ? 64 : 95, c = g.state === 'lift' ? 13 : 17.5;
      const pvx = g.vx, pvy = g.vy;
      g.vx += (k * (T.x - g.x) - c * g.vx) * dt; g.vy += (k * (T.y - g.y) - c * g.vy) * dt; g.vz += (k * (T.z - g.z) - c * g.vz) * dt;
      g.x += g.vx * dt; g.y += g.vy * dt; g.z += g.vz * dt;
      ax = (g.vx - pvx) / dt; ay = (g.vy - pvy) / dt;
      if (g.state === 'return' && ((Math.abs(T.x - g.x) < 5 && Math.abs(T.y - g.y) < 8 && Math.abs(g.z - T.z) < 8) || g.flightT > 1.1)) {
        g.state = 'drop'; g.x -= rail.ox; g.vy = Math.max(0, g.vy); g.delay = 0; setLayer(g, 0); g.layer = 0;
      }
    }

    // --- hook swivel: angled on the rail, turns to show its curl when held up in the viewer
    if (!g.hookRest) g.hookRest = g.hookYaw;
    const hyT = (g.state === 'lift') ? Math.sign(g.hookRest) * 1.3 : g.hookRest;
    g.hookYawV += (120 * (hyT - g.hookYaw) - 16 * g.hookYawV) * dt; g.hookYaw += g.hookYawV * dt;
    // --- yaw (turn) with a lagging hem that twists
    const yPrev = g.yawV;
    g.yawTarget = g.state === 'lift' ? g.yawTarget : g.state === 'return' || g.state === 'drop' ? g.yawTarget : (g.i === focus ? nearestEquiv(g.heroYaw, g.yaw) : nearestEquiv(g.restYaw, g.yaw));
    g.yawV += (K.yaw * (g.yawTarget - g.yaw) - K.yawC * g.yawV) * dt; g.yaw += g.yawV * dt;
    g.yawHV += (K.hemY * (g.yaw - g.yawH) - K.hemYC * g.yawHV) * dt; g.yawH += g.yawHV * dt;
    { const tw = g.yawH - g.yaw, lim = 0.34; if (Math.abs(tw) > lim) { g.yawH = g.yaw + Math.sign(tw) * (lim + (Math.abs(tw) - lim) * 0.25); g.yawHV = g.yawV + (g.yawHV - g.yawV) * 0.5; } }
    swishAcc += Math.abs(g.yawV);

    // --- pendulum swing about the hook
    let tq = 0;
    tq += -K.w0 * Math.sin(g.phi) - (g.state === 'lift' ? K.phiC * 2.2 : K.phiC) * g.phiV;
    tq += -(ax / L) * Math.cos(g.phi) * (g.state === 'lift' || g.state === 'return' ? 0.32 : 0.4) - (ay / L) * Math.sin(g.phi) * 0.3;
    tq += K.breeze * Math.sin(t * 0.55 + g.i * 1.7) * (1 + 0.6 * Math.sin(t * 0.21 + g.i * 2.3));
    tq += g.torque; g.torque = 0;
    // cursor brushing through the garment
    if (K.brush && P.inside && pv > 40 && lifted < 0 && (g.state === 'hung')) {
      const r = bodyRect(g), half = (r.r - r.l) / 2 + 10;
      const dx = P.x - r.cx, inY = P.y > r.t - hangDrop && P.y < r.b + 6;
      if (inY && Math.abs(dx) < half * 1.6) {
        const prox = Math.abs(dx) < half ? 1 - Math.abs(dx) / half * 0.5 : 0.25 * (1 - (Math.abs(dx) - half) / (half * 0.6));
        const lever = clamp((P.y - r.t) / g.h, 0.15, 1);
        tq += K.brush * clamp(P.vx, -2600, 2600) * prox * lever / L;
        g.pitchV += clamp(P.vy, -2000, 2000) * prox * lever * 0.0009;
        g.vx += clamp(P.vx, -2600, 2600) * prox * dt * 1.1;
      }
    }
    if (g.state === 'lift' && P.inside && pv > 40 && !viewerDrag && lifted === g.i) tq += K.brush * 0.35 * clamp(P.vx, -2000, 2000) / (L * 4);
    g.phiV += tq * dt; g.phi += g.phiV * dt;
    g.phi = clamp(g.phi, -0.9, 0.9);
    // hem follows the body with lag (cloth secondary motion)
    g.hemV += (K.hemS * (g.phi - g.hem) - K.hemSC * g.hemV) * dt; g.hem += g.hemV * dt;
    g.pitchV += (-K.pitch * g.pitch - K.pitchC * g.pitchV) * dt; g.pitch += g.pitchV * dt; g.pitch = clamp(g.pitch, -0.5, 0.5);
    const ripT = REDUCED ? 0 : clamp(Math.abs(g.yawV) * 0.011 * S + Math.abs(g.phiV) * 0.03 * S + Math.abs(g.pitchV) * 0.02 * S + Math.abs(g.yaw - g.yawH) * 0.03 * S, 0, 0.04 * S);
    g.rip += (ripT - g.rip) * Math.min(1, dt * 10);
  }

  // fabric-on-fabric contact: neighbours bump and absorb instead of passing through each other
  const hung = items.filter(g => g.state === 'hung' || g.state === 'drop').sort((a, b) => a.x - b.x);
  for (let k = 0; k < hung.length - 1; k++) {
    const a = hung[k], b = hung[k + 1];
    collide(a, b);
    // hooks knocking together
    const rel = a.vx - b.vx, hd = b.x - a.x;
    if (rel > 220 && hd < 0.5 * (a.wv + b.wv) * 0.8 && t - a.lastClink > 0.12 && clinkBudget < 3) { a.lastClink = t; clinkBudget++; Sound.clink(clamp(rel / 1500, 0.15, 0.7)); }
  }
  Sound.update(slideAcc / 2200, swishAcc / 30);
}


/* ---------------- rooms, spotlight, decor ---------------- */
// order = shader index in backdrop.js. "open" rooms have no wall: no wall shadows, brackets crack the scene, and the
// chrome reflects env (top, horizon, below, sun strength)
const THEMES = [
  { id: 'limestone', tone: 'light' },
  { id: 'sky', tone: 'light', open: true, env: [[0.3, 0.5, 0.82], [0.7, 0.82, 0.94], [0.33, 0.35, 0.32], 1] },
  { id: 'castle', tone: 'dark' },
  { id: 'forest', tone: 'dark', open: true, env: [[0.5, 0.6, 0.38], [0.32, 0.42, 0.26], [0.07, 0.11, 0.05], 0.55] },
  { id: 'galaxy', tone: 'dark', open: true, env: [[0.16, 0.1, 0.3], [0.12, 0.14, 0.24], [0.02, 0.02, 0.05], 0.15] },
  { id: 'matrix', tone: 'dark', open: true, env: [[0.06, 0.34, 0.14], [0.03, 0.18, 0.07], [0.0, 0.04, 0.02], 0.12] },
  { id: 'lanterns', tone: 'dark', open: true, env: [[0.1, 0.07, 0.22], [0.55, 0.3, 0.18], [0.04, 0.03, 0.08], 0.25] },
  { id: 'sakura', tone: 'light' },
  { id: 'garden', tone: 'light' },
];
const SAKURA = THEMES.findIndex(x => x.id === 'sakura');
const ROOM_KEY = opts.roomKey === undefined ? 'otk-armory-room-v2' : opts.roomKey;
let theme = clamp(opts.room | 0, 0, THEMES.length - 1), themePrev = theme, themeMix = 1, themeT = 1, themeApplied = theme, lastDt = 1 / 60;
try { const t = ROOM_KEY ? parseInt(localStorage.getItem(ROOM_KEY), 10) : NaN; if (t >= 0 && t < THEMES.length) theme = themePrev = themeApplied = t; } catch (e) {}
const reveal = new THREE.Vector2(0, 0);
const spotS = { x: 0, y: 0, vx: 0, vy: 0 }, spotFixture = { x: 0, y: 0, z: 0 };

const bgMat = new THREE.ShaderMaterial({
  vertexShader: window.OTK_BACKDROP.vert, fragmentShader: window.OTK_BACKDROP.frag, depthTest: false, depthWrite: false,
  uniforms: {
    uRes: { value: new THREE.Vector2(1, 1) }, uDpr: { value: 1 }, uTime: globals.uTime,
    uTheme: { value: theme }, uPrev: { value: theme }, uMix: { value: 1 }, uReveal: { value: reveal },
    uTarget: { value: new THREE.Vector2() }, uFixture: { value: new THREE.Vector3() },
    uRail: { value: new THREE.Vector4() }, uRailOff: { value: new THREE.Vector2() }, uRailDepth: { value: 46 },
    uS: { value: 200 },
    uSakura: { value: blankTex() }, uSakuraAspect: { value: 1.6 }, uGlyphs: { value: glyphAtlas() }
  }
});
function blankTex() { const t = new THREE.DataTexture(new Uint8Array([0, 0, 0, 0]), 1, 1); t.needsUpdate = true; textures.push(t); return t; }
// 64 mirrored half-width katakana, digits and symbols in an 8 x 8 sheet for the digital rain. No mipmaps, so sampling
// per cell can't hit the undefined-mip-level problem described in samp().
function glyphAtlas() {
  const c = document.createElement('canvas'); c.width = c.height = 256; const g = c.getContext('2d');
  const chars = 'ｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝ0123456789Z:.=*+-<>';
  g.fillStyle = '#fff'; g.textAlign = 'center'; g.textBaseline = 'middle';
  g.font = 'bold 25px "Hiragino Kaku Gothic ProN","Hiragino Sans","Meiryo","Noto Sans JP","MS Gothic",monospace';
  for (let i = 0; i < 64; i++) { g.save(); g.translate((i % 8) * 32 + 16, Math.floor(i / 8) * 32 + 17); g.scale(-1, 1); g.fillText(chars[i % chars.length], 0, 0); g.restore(); }
  const t = new THREE.CanvasTexture(c); t.minFilter = t.magFilter = THREE.LinearFilter; t.generateMipmaps = false; textures.push(t); return t;
}
let sakuraState = 0;
function needSakura() {
  const src = (opts.decor || {}).sakura; if (sakuraState || !src) return; sakuraState = 1;
  loader.load(src, tx => { tx.minFilter = THREE.LinearMipmapLinearFilter; tx.generateMipmaps = true; tx.anisotropy = 4; textures.push(tx);
    bgMat.uniforms.uSakura.value = tx; bgMat.uniforms.uSakuraAspect.value = tx.image.width / tx.image.height; sakuraState = 2; }, undefined, () => { sakuraState = 0; });
}
const bgMesh = new THREE.Mesh(new THREE.PlaneGeometry(2, 2), bgMat);
bgMesh.frustumCulled = false; bgMesh.renderOrder = -1000; scene.add(bgMesh);

// wall brackets in the same chrome as the rail, in every room (in the open sky they bolt into the sky, which cracks)
const metalExtras = [];
function metalPiece(geo, x, y) { const m = new THREE.Mesh(geo, mkMetal(null, true)); m.material.uniforms.uPivot.value.set(x, y); m.frustumCulled = false; scene.add(m); metalExtras.push(m); return m; }
function buildBrackets() {
  metalExtras.splice(0).forEach(m => { scene.remove(m); m.geometry.dispose(); m.material.dispose(); });
  const depth = -globals.uWallZ.value, r = railRad;
  [railL, railR].forEach(x => {
    const arm = new THREE.CylinderGeometry(r * 0.8, r * 0.8, depth, 16); arm.rotateX(Math.PI / 2); arm.translate(0, 0, -depth / 2);
    const fl = new THREE.CylinderGeometry(r * 2.5, r * 2.5, 3, 28); fl.rotateX(Math.PI / 2); fl.translate(0, 0, -depth + 1.5);
    const cap = new THREE.SphereGeometry(r * 1.15, 18, 12);
    metalPiece(arm, x, railY); metalPiece(fl, x, railY); metalPiece(cap, x, railY);
  });
}

function updateSpot(dt) {
  // a motorised follow-spot: fixed fixture, the beam pans after the cursor with a little inertia
  const idle = !(P.inside && lifted < 0);
  const tx = idle ? W / 2 + Math.sin(simT * 0.17) * W * 0.05 : clamp(P.x, W * 0.08, W * 0.92);
  const cy = railY + S * 0.45;
  const ty = idle ? cy : clamp(cy + (P.y - cy) * 0.3, railY - S * 0.1, railY + S * 1.0);
  const n = Math.max(1, Math.ceil(dt / (1 / 120))), h = dt / n;
  for (let k = 0; k < n; k++) {
    spotS.vx += (14 * (tx - spotS.x) - 6.2 * spotS.vx) * h; spotS.x += spotS.vx * h;
    spotS.vy += (14 * (ty - spotS.y) - 6.2 * spotS.vy) * h; spotS.y += spotS.vy * h;
  }
  // theme reveal progress
  if (themeT < 1) {
    themeT = Math.min(1, themeT + dt / (REDUCED ? 0.01 : 1.5));
    themeMix = themeT < 0.5 ? 2 * themeT * themeT : 1 - Math.pow(-2 * themeT + 2, 2) / 2;
    if (themeT >= 0.5 && themeApplied !== theme) { themeApplied = theme; applyThemeDom(); }
  }
  // shelves catch the light like everything else on the wall
  racks.forEach(rk => {
    const cx = rk.el.offsetLeft + rk.el.offsetWidth / 2, cy2 = rk.el.offsetTop + rk.el.offsetHeight / 2;
    const b = 1;
    if (Math.abs(b - rk.b) > 0.004) { rk.b = b; rk.el.style.filter = `brightness(${b.toFixed(3)})`; }
  });
  updateHats(dt);
}
function syncBackdrop() {
  const u = bgMat.uniforms;
  u.uRes.value.set(W, H); u.uDpr.value = renA.getPixelRatio();
  u.uTheme.value = theme; u.uPrev.value = themePrev; u.uMix.value = themeMix;
  u.uTarget.value.set(spotS.x, spotS.y);
  u.uFixture.value.set(spotFixture.x, spotFixture.y, spotFixture.z);
  u.uRail.value.set(railL, railR, railY, railRad); u.uRailOff.value.set(rail.ox, rail.oy);
  u.uRailDepth.value = -globals.uWallZ.value;
  u.uS.value = S;
}

/* ---------------- "One True King" <-> logo: particles diffuse from one into the other on hover (tap on touch) ---------------- */
const title = (() => {
  const el = $('.armory__title'), cv = $('.armory__title-fx');
  if (!el || !cv) return { prepare() {}, tick() {} };
  const g = cv.getContext('2d');
  let N = 0, ax, ay, bx, by, ca, cb, dl, an, am, cw = 0, ch = 0, buf = null, t = 0, target = 0, shown = -1, logo = null, logoRect = null, ready = false;
  const rnd = (i, k) => { const x = Math.sin(i * 12.9898 + k * 78.233) * 43758.5453; return x - Math.floor(x); };
  function sample(draw) {                       // opaque pixels of a drawing on a grid, as [x, y, r, g, b] in device px
    const c = document.createElement('canvas'); c.width = cw; c.height = ch; const x = c.getContext('2d'); draw(x);
    const d = x.getImageData(0, 0, cw, ch).data, out = [], step = Math.max(1, Math.round(1.5 * (cw / cv.clientWidth)));
    for (let yy = 0; yy < ch; yy += step) for (let xx = 0; xx < cw; xx += step) { const i = (yy * cw + xx) * 4; if (d[i + 3] > 140) out.push([xx, yy, d[i], d[i + 1], d[i + 2]]); }
    return out.sort((p, q) => p[0] - q[0] || p[1] - q[1]);
  }
  function prepare() {
    const r = cv.getBoundingClientRect(); if (!r.width) return;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    cw = cv.width = Math.round(r.width * dpr); ch = cv.height = Math.round(r.height * dpr); buf = g.createImageData(cw, ch);
    logo = $(root.dataset.tone === 'dark' ? '.armory__logo--light' : '.armory__logo--dark');
    if (!logo || !logo.complete || !logo.naturalWidth) { if (logo) logo.addEventListener('load', prepare, { once: true }); return; }
    const cs = getComputedStyle(el), er = el.getBoundingClientRect();
    const font = `${cs.fontStyle} ${cs.fontWeight} ${parseFloat(cs.fontSize) * dpr}px ${cs.fontFamily}`;
    const cx = (er.left + er.width / 2 - r.left) * dpr, cy = (er.top - r.top) * dpr, lh = er.height * dpr;
    const A = sample(x => { x.font = font; x.fillStyle = cs.color; x.textAlign = 'center'; x.textBaseline = 'alphabetic';
      const m = x.measureText(el.textContent); const asc = m.fontBoundingBoxAscent || m.actualBoundingBoxAscent, des = m.fontBoundingBoxDescent || m.actualBoundingBoxDescent;
      x.fillText(el.textContent, cx, cy + (lh - (asc + des)) / 2 + asc); });
    const h = Math.min(72, Math.max(46, H * 0.072)) * dpr, w = h * logo.naturalWidth / logo.naturalHeight;
    logoRect = [cx - w / 2, cy + lh / 2 - h / 2, w, h];
    const B = sample(x => x.drawImage(logo, ...logoRect));
    if (!A.length || !B.length) return;
    N = Math.min(7000, Math.max(A.length, B.length));
    [ax, ay, bx, by, dl, an, am] = [0, 0, 0, 0, 0, 0, 0].map(() => new Float32Array(N)); ca = new Uint8ClampedArray(N * 3); cb = new Uint8ClampedArray(N * 3);
    for (let i = 0; i < N; i++) {
      const p = A[Math.floor(i * A.length / N)], q = B[Math.floor(i * B.length / N)];
      ax[i] = p[0]; ay[i] = p[1]; bx[i] = q[0]; by[i] = q[1];
      ca.set(p.slice(2), i * 3); cb.set(q.slice(2), i * 3);
      dl[i] = rnd(i, 1) * 0.35; an[i] = rnd(i, 2) * 6.283; am[i] = (10 + rnd(i, 3) * 34) * dpr;
    }
    ready = true; shown = -1; draw();
  }
  function draw() {
    if (t === shown) return; shown = t;
    el.classList.toggle('is-fx', t > 0);
    g.clearRect(0, 0, cw, ch);
    if (!ready || t === 0) return;
    if (t === 1) { g.drawImage(logo, ...logoRect); return; }
    const d = buf.data; d.fill(0);
    for (let i = 0; i < N; i++) {
      const k = Math.min(1, Math.max(0, t * 1.35 - dl[i])), e = k * k * (3 - 2 * k), s = Math.sin(Math.PI * k) * am[i], th = an[i] + k * 4;
      const x = Math.round(ax[i] + (bx[i] - ax[i]) * e + Math.cos(th) * s), y = Math.round(ay[i] + (by[i] - ay[i]) * e + Math.sin(th) * s);
      if (x < 0 || y < 0 || x >= cw - 1 || y >= ch - 1) continue;
      const r = ca[i * 3] + (cb[i * 3] - ca[i * 3]) * e, gg = ca[i * 3 + 1] + (cb[i * 3 + 1] - ca[i * 3 + 1]) * e, b = ca[i * 3 + 2] + (cb[i * 3 + 2] - ca[i * 3 + 2]) * e;
      for (let o = 0; o < 4; o++) { const j = ((y + (o >> 1)) * cw + x + (o & 1)) * 4; d[j] = r; d[j + 1] = gg; d[j + 2] = b; d[j + 3] = 255; }
    }
    g.putImageData(buf, 0, 0);
  }
  function tick(dt) {
    if (t !== target) t = REDUCED ? target : target > t ? Math.min(1, t + dt / 1.15) : Math.max(0, t - dt / 1.15);
    draw();
  }
  el.addEventListener('pointerenter', e => { if (e.pointerType !== 'touch') target = 1; });
  el.addEventListener('pointerleave', e => { if (e.pointerType !== 'touch') target = 0; });
  el.addEventListener('click', () => { if (COARSE) target = target ? 0 : 1; });
  if (document.fonts && document.fonts.load) document.fonts.load(`italic 40px ${getComputedStyle(el).fontFamily}`).then(() => prepare());
  return { prepare, tick, set(v) { target = v; } };
})();

/* decor DOM: logo, shelves, ticker, shield */
const racks = [];
function buildDecor() {
  const D0 = opts.decor || {};
  if (D0.logo_dark) { [['dark', D0.logo_dark], ['light', D0.logo_light]].forEach(([k, src]) => { const im = $(`.armory__logo--${k}`); im.crossOrigin = 'anonymous'; im.src = src; }); }
  const track = $('.armory__track'); let html = '';
  for (let k = 0; k < 12; k++) html += '<span>Modern Day Armor</span><i>&#9670;</i><span>@otk.digital</span><i>&#9670;</i>';
  track.innerHTML = html + html;
  ['l', 'r'].forEach(side => {
    const el = $(`.armory__rack--${side}`); if (!el) return;
    el.querySelector('.armory__rail-img').src = D0.peg_rail || '';
    const caps = el.querySelector('.armory__caps'), label = el.querySelector('.armory__hatlabel');
    const rack = { el, b: 1, hats: [], pegs: [] }; racks.push(rack);
    const list = (D0.hats || []).filter(h => h.shelf === side);
    list.forEach((h, k) => {
      const peg = document.createElement('span'); peg.className = 'armory__peg';
      el.insertBefore(peg, el.querySelector('.armory__rail-img')); rack.pegs.push(peg);
      const a = document.createElement('a'); a.className = 'armory__hat'; a.href = h.url; if (opts.newTab !== false) { a.target = '_blank'; a.rel = 'noopener'; }
      a.setAttribute('aria-label', `${h.name}, ${priceOf(h)}`);
      const img = document.createElement('img'); img.src = h.src; img.alt = ''; a.append(img); caps.append(a);
      const hat = { h, el: a, k, n: list.length, th: 0, w: 0, rest: 0, L: 40, inside: false, armed: false, px: 0, py: 0, hw: 0, hh: 0 };
      rack.hats.push(hat);
      const show = () => { label.querySelector('b').textContent = h.name; const sp = label.querySelector('span'); sp.textContent = ''; const em = document.createElement('em'); em.textContent = priceOf(h); sp.append(em); el.classList.add('is-hover'); };
      const hide = () => { el.classList.remove('is-hover'); hat.armed = false; };
      // a lifted finger always "leaves", so on touch the cap stays armed until the next tap lands somewhere else
      a.addEventListener('pointerenter', show); a.addEventListener('pointerleave', e => { if (e.pointerType !== 'touch') hide(); });
      root.addEventListener('pointerdown', e => { if (e.pointerType === 'touch' && !a.contains(e.target)) hide(); });
      a.addEventListener('focus', () => { show(); hat.w += 1.2; }); a.addEventListener('blur', hide);
      a.addEventListener('click', ev => { if (COARSE && !hat.armed) { ev.preventDefault(); hat.armed = true; show(); hat.w += 1.6; } });
    });
  });
  const shield = $('.armory__shield');
  shield.addEventListener('click', () => {
    const r = shield.getBoundingClientRect(), rr = root.getBoundingClientRect();
    reveal.set(r.left - rr.left + r.width / 2, r.top - rr.top + r.height / 2);
    needSakura();   // fetch the cherry tree early, before anyone reaches its room
    applyTheme((theme + 1) % THEMES.length, true);
    shield.classList.remove('is-spin'); void shield.offsetWidth; shield.classList.add('is-spin');
    setTimeout(() => shield.classList.remove('is-spin'), 800);
    if (Sound.on) { Sound.clink(1); setTimeout(() => Sound.clink(0.6), 90); }
  });
}
function applyTheme(i, animate) {
  if (animate && themeT < 1) { themePrev = theme; }       // clicking mid-reveal: start from where we are
  else themePrev = animate ? theme : i;
  theme = i;
  if (i === SAKURA) needSakura();
  if (animate) { themeT = 0; themeMix = 0; } else { themeT = 1; themeMix = 1; themeApplied = i; applyThemeDom(); }
  if (animate && ROOM_KEY) try { localStorage.setItem(ROOM_KEY, String(i)); } catch (e) {}   // only a visitor's own pick is remembered
}
function applyThemeDom() {
  const t = THEMES[themeApplied], retone = root.dataset.tone !== t.tone;
  root.dataset.theme = t.id; root.dataset.tone = t.tone;
  layoutDecor();
  if (retone) title.prepare();   // the text colour and logo version follow the room's tone
}
function layoutRacks() {
  // caps sit on turned pegs that rise from a walnut rail below them; each cap pivots where the peg meets the inside of its crown
  racks.forEach(rk => {
    const rw = rk.el.offsetWidth, boardH = rw * 104 / 700;
    const sizes = rk.hats.map(ht => { const hw = rw * 0.36, hh = hw / ht.h.aspect; return { hw, hh }; });
    const above = Math.max(...sizes.map((z, k) => rk.hats[k].h.pivot[1] * z.hh), 10);
    const below = Math.max(...sizes.map((z, k) => (1 - rk.hats[k].h.pivot[1]) * z.hh), 10);
    const pivotY = 6 + above, boardTop = pivotY + below + Math.max(10, rw * 0.045);
    rk.el.style.height = (boardTop + boardH) + 'px';
    const img = rk.el.querySelector('.armory__rail-img'); img.style.top = boardTop + 'px';
    rk.hats.forEach((ht, k) => {
      const { hw, hh } = sizes[k];
      const pegX = rw * (ht.n > 1 ? 0.28 + 0.44 * k / (ht.n - 1) : 0.5);
      const pv = ht.h.pivot, cm = ht.h.com;
      Object.assign(ht.el.style, { width: hw + 'px', left: (pegX - pv[0] * hw) + 'px', top: (pivotY - pv[1] * hh) + 'px', transformOrigin: `${pv[0] * 100}% ${pv[1] * 100}%` });
      const pw = Math.max(6, rw * 0.026), peg = rk.pegs[k];
      Object.assign(peg.style, { left: (pegX - pw / 2) + 'px', top: (pivotY + hh * 0.08) + 'px', width: pw + 'px', height: (boardTop - pivotY - hh * 0.08 + boardH * 0.3) + 'px' });
      const dx = (cm[0] - pv[0]) * hw, dy = (cm[1] - pv[1]) * hh;
      ht.rest = clamp(-Math.atan2(dx, dy), -0.12, 0.12); ht.L = Math.max(10, Math.hypot(dx, dy));
      if (!ht.placed) { ht.th = ht.rest; ht.placed = true; }
      ht.px = rk.el.offsetLeft + pegX; ht.py = rk.el.offsetTop + pivotY; ht.hw = hw; ht.hh = hh;
    });
  });
}
// caps rock on their pegs like little pendulums: brushed by the cursor, kicked when touched
function updateHats(dt) {
  const n = Math.max(1, Math.ceil(dt / (1 / 240))), h = dt / n;
  racks.forEach(rk => rk.hats.forEach(ht => {
    const pv = ht.h.pivot;
    let inside = false, lever = 0, near = 0;
    if (P.inside && lifted < 0) {
      const vx = P.x - ht.px, vy = P.y - ht.py, c = Math.cos(ht.th), s = Math.sin(ht.th);
      const lx = vx * c + vy * s, ly = -vx * s + vy * c;
      const x0 = -pv[0] * ht.hw, x1 = (1 - pv[0]) * ht.hw, y0 = -pv[1] * ht.hh, y1 = (1 - pv[1]) * ht.hh;
      inside = lx > x0 && lx < x1 && ly > y0 && ly < y1;
      near = inside ? 1 : (lx > x0 - 18 && lx < x1 + 18 && ly > y0 - 10 && ly < y1 + 10) ? 0.3 : 0;
      lever = clamp(ly / ht.hh, 0.15, 1);
    }
    if (inside && !ht.inside && !REDUCED) ht.w += clamp(P.vx / 700, -1.4, 1.4) + (P.vx >= 0 ? 0.25 : -0.25);
    ht.inside = inside;
    for (let k = 0; k < n; k++) {
      let tq = -70 * Math.sin(ht.th - ht.rest) - 2.4 * ht.w;
      if (near && !REDUCED) tq += 1.5 * clamp(P.vx, -2400, 2400) * near * lever / ht.L;
      ht.w += tq * h; ht.th += ht.w * h;
    }
    if (Math.abs(ht.th - ht.rest) > 0.32) { ht.th = ht.rest + Math.sign(ht.th - ht.rest) * 0.32; ht.w *= -0.3; }
    const v = ht.th.toFixed(4);
    if (v !== ht.last) { ht.last = v; ht.el.style.transform = `rotate(${v}rad)`; }
  }));
}
function layoutDecor() {
  spotFixture.x = W / 2; spotFixture.y = -H * 0.55; spotFixture.z = H * 0.95;
  layoutRacks();
}

/* ---------------- render ---------------- */
let last = 0, t0 = 0, simT = 0, introStart = 0;
function syncUniforms() {
  updateSpot(lastDt);
  lightX = W * 0.32;   // soft room key from the upper left
  syncBackdrop();
  railMat.uniforms.uRailOff.value.set(rail.ox, rail.oy); railMat.uniforms.uLight.value.set(clamp((lightX - W / 2) / (W * 0.45), -1, 1) * 0.6, 0);
  metalExtras.forEach(m => { m.material.uniforms.uRailOff.value.set(rail.ox, rail.oy); m.material.uniforms.uLight.value.set(clamp((lightX - W / 2) / (W * 0.45), -1, 1) * 0.6, 0); });
  G.forEach(g => { if (!g.visible) Object.values(g.parts).forEach(m => m.visible = false); });
  const wall = i => THEMES[i].open ? 0 : 1, wallness = lerp(wall(themePrev), wall(theme), themeMix);   // fades with the reveal
  globals.uOpen.value = 1 - wallness;
  { const eB = THEMES[theme].env || THEMES[themePrev].env, eA = THEMES[themePrev].env || eB;
    if (eA) { const m = themeMix; ['uEnvTop', 'uEnvHor', 'uEnvLow'].forEach((k, j) => globals[k].value.set(lerp(eA[j][0], eB[j][0], m), lerp(eA[j][1], eB[j][1], m), lerp(eA[j][2], eB[j][2], m)));
      globals.uEnvSun.value = lerp(eA[3], eB[3], m); } }
  title.tick(lastDt);
  const order = G.filter(g => g.visible).sort((a, b) => (a.z - b.z) || (a.i - b.i));
  order.forEach((g, rank) => {
    const s = g.sh, onRail = g.state !== 'lift' && g.state !== 'return';
    const px = g.x + (onRail ? rail.ox : 0);
    s.uPivot.value.set(px, g.y); s.uPivotZ.value = g.z;
    s.uHookYaw.value = g.hookYaw; s.uYawTop.value = g.yaw; s.uYawHem.value = g.yawH; s.uYawMid.value = g.yaw * 0.6 + g.yawH * 0.4; s.uSwing.value = g.phi; s.uHem.value = g.hem; s.uPitch.value = g.pitch; s.uRipple.value = g.rip;
    s.uLight.value.set(clamp((lightX - px) / (W * 0.45), -1, 1) * 0.95, 0);
    s.uShadowOff.value.set((px - W / 2) * 0.012, S * 0.05);
    const ym = g.yaw * 0.6 + g.yawH * 0.4, af = g.wF * Math.abs(Math.cos(ym)), as = g.wS * Math.abs(Math.sin(ym));
    const fv = g.side ? smooth(0.488, 0.512, af / (af + as + 0.001)) : 1;
    g.faceA = 1; g.sideA = 1;
    const shown = g.state !== 'wait' && g.visible ? 1 : 0;
    const lit = wallness;   // no wall behind the rack in the open sky, so no shadows on it
    const shadowK = window.__noShadow ? 0 : shown * (1 - clamp(g.z / (D * 0.12), 0, 1)) * 0.13 * lit;
    const p = g.parts;
    p.face.material.uniforms.uAlpha.value = g.faceA * shown;
    p.shadowFace.material.uniforms.uAlpha.value = shadowK * fv;
    if (p.side) { p.side.material.uniforms.uAlpha.value = g.sideA * shown; p.shadowSide.material.uniforms.uAlpha.value = (1 - fv) * shadowK; }
    p.hook.material.uniforms.uAlpha.value = 1;
    const base = rank * 10 + 10;
    p.shadowFace.renderOrder = -100 + rank; if (p.shadowSide) p.shadowSide.renderOrder = -100 + rank;
    p.face.renderOrder = base + 1; if (p.side) p.side.renderOrder = base + 2; p.hook.renderOrder = base + 3;
    Object.values(p).forEach(m => m.visible = !!shown && !window.__noGarments);
  });
  // floating label under the focused piece
  const fg = G[focus];
  if (fg && lifted < 0 && fg.state === 'hung') {
    const lx = clamp(fg.x + rail.ox, 90, W - 90);
    labelEl.style.left = lx.toFixed(1) + 'px'; labelEl.style.top = (railY + hangDrop + S * 1.0 + 18).toFixed(1) + 'px';
    labelEl.classList.add('is-on'); labelEl.classList.toggle('is-kbd', kbdFocus);
  } else labelEl.classList.remove('is-on', 'is-kbd');
}
function frame(now) {
  if (!running) { last = 0; return; }
  requestAnimationFrame(frame);
  if (!last) last = now;
  let dt = Math.min(0.05, (now - last) / 1000); last = now; lastDt = dt;
  if (pending > 0) return; // wait for textures before the intro
  if (!introStart) { introStart = simT + 0.001; startIntro(); }
  const sub = Math.ceil(dt / (1 / 240)), h = dt / sub;
  clinkBudget = 0;
  for (let k = 0; k < sub; k++) { simT += h; physics(h, simT); }
  globals.uTime.value = simT;
  syncUniforms();
  cam.layers.set(0); renA.render(scene, cam);
  const flying = G.some(g => g.layer === 1);
  if (flying || liftCanvas.dataset.dirty) { cam.layers.set(1); renB.render(scene, cam); liftCanvas.dataset.dirty = flying ? '1' : ''; }
}
function startIntro() {
  const vis = G.filter(g => g.visible);
  vis.forEach((g, k) => {
    g.x = g.rest; g.tx = g.rest;
    if (REDUCED) { g.state = 'hung'; g.y = railY; }
    else { g.state = 'drop'; g.delay = simT + 0.15 + k * 0.075; g.y = railY - S * 1.4 - 160; g.vy = 0; g.phi = (Math.random() - 0.5) * 0.3; }
  });
  introDone = true;
}

/* ---------------- lifecycle ---------------- */
buildDecor(); layoutMetrics(); lightX = W / 2; spotS.x = W / 2; spotS.y = railY + S * 0.45; applyTheme(theme, false);
const ro = new ResizeObserver(() => { layoutMetrics(); }); ro.observe(root);
let inView = false;
const io = new IntersectionObserver(es => { inView = es[es.length - 1].isIntersecting; if (inView && !running && !document.hidden) { running = true; requestAnimationFrame(frame); } else if (!inView) running = false; }, { threshold: 0.2 });
io.observe(root);
const onVis = () => { if (document.hidden) running = false; else if (inView && !running) { running = true; requestAnimationFrame(frame); } };
document.addEventListener('visibilitychange', onVis);
function destroy() {
  running = false; io.disconnect(); ro.disconnect(); clearTimeout(unfocusTimer);
  document.removeEventListener('keydown', onKey); document.removeEventListener('visibilitychange', onVis);
  scene.traverse(o => { if (o.geometry) o.geometry.dispose(); if (o.material) o.material.dispose(); });
  textures.forEach(t => t.dispose());
  [renA, renB].forEach(r => { r.dispose(); r.forceContextLoss(); });   // free the GL contexts (the theme editor re-mounts often)
  if (Sound.ctx) Sound.ctx.close();
  if (window.__armory === api) delete window.__armory;
}
function advance(sec, draw = true){ if(!introStart){introStart=0.001;startIntro();} const n=Math.round(sec*240); for(let k=0;k<n;k++){simT+=1/240; physics(1/240,simT);} globals.uTime.value=simT; lastDt=sec; syncUniforms(); if(!draw) return; cam.layers.set(0); renA.render(scene,cam); cam.layers.set(1); renB.render(scene,cam); }
const api = { advance, pause(){running=false;}, CONTACT, setTheme(i){ applyTheme(i,false); }, G, get focus() { return focus; }, setFocus, openViewer, closeViewer, P, rail, get S() { return S; }, title(v) { title.set(v); }, get room() { return theme; }, rooms: THEMES.map(x => x.id), destroy };
window.__armory = api;
return api;
};

/* Shopify glue for The Armory (bundled after backdrop.js + engine.js into assets/otk-armory.js).
   Each [data-otk-armory] section starts only when it nears the viewport: three.js r128 is loaded once from cdnjs,
   otk-armory-data.json (geometry + texture file names, keyed by product handle) is fetched once, and the live product
   data Liquid rendered into the section (title, price, URL, availability) is merged in by handle. Products without
   packed images are skipped. The theme editor's shopify:section:load / unload mount and destroy instances. */
(() => {
'use strict';
if (window.OTK_ARMORY_SHOPIFY) { window.OTK_ARMORY_SHOPIFY.scan(); return; }   // script re-run by the theme editor

const THREE_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
const THREE_SRI = 'sha512-dLxUelApnYxpLt6K2iomGngnHO83iUvZytA3YjDUCjT0HDOHKXnVYdf3hU4JjM8uEhxf9nD1/ey98U3t2vZ0qQ==';
const MAX_TEES = 10, MAX_CAPS = 4;
let threeP = null;
const dataP = {};

function loadThree() {
  if (window.THREE) return Promise.resolve();
  return threeP || (threeP = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = THREE_SRC; s.integrity = THREE_SRI; s.crossOrigin = 'anonymous'; s.async = true;
    s.onload = () => resolve(); s.onerror = () => { threeP = null; s.remove(); reject(new Error('three.js did not load')); };
    document.head.appendChild(s);
  }));
}
function loadData(url) {
  return dataP[url] || (dataP[url] = fetch(url).then(r => { if (!r.ok) throw new Error('otk-armory-data.json ' + r.status); return r.json(); })
    .catch(e => { delete dataP[url]; throw e; }));
}

function assemble(root, data) {
  const base = root.dataset.assets;
  const file = f => base + f.file + '?v=' + f.v;
  const live = JSON.parse(root.querySelector('[data-armory-products]').textContent);
  const shop = p => ({ title: p.title, url: p.url, price: p.price, priceText: p.priceText, available: p.available });
  const garments = live.tees.filter(p => data.garments[p.handle]).slice(0, MAX_TEES).map(p => {
    const g = data.garments[p.handle], views = {};
    Object.keys(g.views).forEach(k => { const v = g.views[k]; views[k] = { src: file(v), bb: v.bb, neck: v.neck }; });
    return Object.assign(shop(p), { hero: g.hero, color: g.color, display: [g.name || p.title, g.sub || ''], views });
  });
  // caps: the first half hang on the left rack, the rest on the right
  const caps = live.caps.filter(p => data.hats[p.handle]).slice(0, MAX_CAPS), nl = Math.ceil(caps.length / 2);
  const hats = caps.map((p, k) => { const h = data.hats[p.handle];
    return Object.assign(shop(p), { name: h.name || p.title, shelf: k < nl ? 'l' : 'r', src: file(h), aspect: h.aspect, pivot: h.pivot, com: h.com }); });
  const d = data.decor;
  return { garments, decor: { hats, logo_dark: file(d.logo_dark), logo_light: file(d.logo_light), peg_rail: file(d.peg_rail), sakura: d.sakura ? file(d.sakura) : '' } };
}

function mount(root) {
  if (root.__otkArmory) return;
  const st = root.__otkArmory = { io: null, api: null };
  const design = !!(window.Shopify && window.Shopify.designMode);
  const start = () => {
    st.io.disconnect();
    Promise.all([loadThree(), loadData(root.dataset.src)]).then(([, data]) => {
      if (root.__otkArmory !== st || !root.isConnected) return;   // unloaded while we were loading
      const o = assemble(root, data);
      st.api = window.OTK_ARMORY(root, Object.assign(o, { room: parseInt(root.dataset.room, 10) || 0, roomKey: design ? null : 'otk-armory-room-v2', newTab: false }));
      root.classList.add(st.api ? 'is-ready' : 'is-nogl');
    }).catch(err => { console.warn('[otk-armory]', err); root.classList.add('is-nogl'); });
  };
  st.io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) start(); }, { rootMargin: '400px 0px' });
  st.io.observe(root);
}
function unmount(root) {
  const st = root.__otkArmory; if (!st) return;
  st.io.disconnect(); if (st.api) st.api.destroy(); delete root.__otkArmory;
}
const scan = (el = document) => el.querySelectorAll('[data-otk-armory]').forEach(mount);

window.OTK_ARMORY_SHOPIFY = { scan, mount, unmount };
document.addEventListener('shopify:section:load', e => scan(e.target));
document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-otk-armory]').forEach(unmount));
scan();
})();
